$(document).ready(function () {

  // browser restores the checked size radio on reload but not the hidden input[name=id]
  // sync the hidden id to the checked size so anything reading it uses the size shown
  function syncVariantIdToCheckedOption($scope) {
    var $scopes = $scope && $scope.length ? $scope : $("product-info, .active-product");
    $scopes.each(function () {
      var $s = $(this);
      var $id = $s.find('input[name="id"]').first();
      var $vs = $s.find("variant-selects").first();
      if (!$id.length || !$vs.length) return;
      var raw = $vs.find("script[data-product-variants]").first().text();
      if (!raw) return;
      var variants;
      try { variants = JSON.parse(raw); } catch (e) { return; }
      var chosen = [];
      $vs.find("fieldset").each(function () {
        var $r = $(this).find('input[type="radio"]:checked').first();
        var $sel = $(this).find("select").first();
        if ($r.length) chosen.push($r.val());
        else if ($sel.length) chosen.push($sel.val());
      });
      if (!chosen.length) return;
      var key = chosen.join("~~");
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        if ((variants[i].options || []).join("~~") === key) { match = variants[i]; break; }
      }
      if (match && String($id.val()) !== String(match.id)) {
        $id.val(match.id);
        console.log("[trikot][variant] synced hidden id to checked size", match.id, match.options);
      }
    });
  }
  syncVariantIdToCheckedOption();

  /* =============================
     Trikot print/back image resolver
     The configurator draws the name/number onto a single "print" image. Historically
     this was hard-coded to the 2nd gallery slide (.eq(1) = col2/r1), which breaks when
     the gallery reorders (selected variant's featured image is promoted to slot 0, media
     reordered, etc.). We now resolve the slide by the media id that Liquid marks via
     data-print-media-id on <media-gallery>. When that attribute is absent we fall back
     to .eq(1) so behaviour is unchanged until an image is flagged.
  ==============================*/
  function getPrintMediaId($scope) {
    var $gallery = $();
    if ($scope && $scope.length) {
      $gallery = $scope.find("media-gallery[data-print-media-id]").first();
    }
    if (!$gallery.length) $gallery = $("media-gallery[data-print-media-id]").first();
    var id = $gallery.attr("data-print-media-id");
    return id ? String(id).trim() : "";
  }

  // The print/back .product__media-item inside a given media list (jQuery).
  function getPrintItem($list) {
    var id = getPrintMediaId($list.closest(".active-product"));
    if (id) {
      var $match = $list.find('.product__media-item[data-media-id$="-' + id + '"]');
      if ($match.length) return $match.first();
    }
    return $list.find(".product__media-item").eq(1);
  }

  // 0-based index of the print/back slide within a media list (for slick navigation).
  function getPrintIndex($list) {
    var $items = $list.find(".product__media-item");
    var idx = $items.index(getPrintItem($list));
    return idx < 0 ? 1 : idx;
  }

  // The print/back <img> for the active product (canvas base + inject target).
  function getPrintImg($activeProduct) {
    return getPrintItem($activeProduct.find(".product__media-list").first()).find("img");
  }

  /* =============================
     Scroll the jersey preview into view after a personalisation action.
     On mobile (<750px) the preview image sits ABOVE the options, so applying a
     badge/name/number/player changes an image the user has scrolled past and
     can't see. Bring it back into view. On desktop the gallery is
     position:sticky and stays on screen, so we skip the scroll whenever the
     preview is already comfortably visible — this keeps desktop from jumping.
  ==============================*/
  function scrollToTrikotPreview($activeProduct) {
    if (!$activeProduct || !$activeProduct.length) return;
    var $wrap = $activeProduct.find(".product__media-wrapper").filter(":visible").first();
    if (!$wrap.length) $wrap = $activeProduct.find(".product__media-wrapper").first();
    if (!$wrap.length) return;

    var rect = $wrap[0].getBoundingClientRect();
    var headerH = parseInt(
      getComputedStyle(document.documentElement).getPropertyValue("--header-height"),
      10
    ) || 0;
    var viewportH = window.innerHeight || document.documentElement.clientHeight;

    // Already comfortably in view (e.g. sticky gallery on desktop) → don't jump.
    if (rect.top >= headerH - 1 && rect.top < viewportH * 0.5) return;

    var target = (window.pageYOffset || window.scrollY || 0) + rect.top - headerH - 12;
    window.scrollTo({ top: Math.max(target, 0), behavior: "smooth" });
  }

  /* =============================
     Navigate the gallery/slider to the print (back) slide — badges, names and
     numbers are all drawn onto that image, so applying one must switch the
     visible slide to it. Mirrors the is-active + slickGoTo pattern already used
     by the name/number/player flows.
  ==============================*/
  function goToPrintSlide($activeProduct) {
    if (!$activeProduct || !$activeProduct.length) return;
    $activeProduct.find(".product__media-list").each(function () {
      var $printItem = getPrintItem($(this));
      if ($printItem.length) {
        $(this).find(".product__media-item").removeClass("is-active");
        $printItem.addClass("is-active");
      }
    });
    if ($activeProduct.find(".product__media_wrap").hasClass("slick-initialized")) {
      $activeProduct.find(".product__media_wrap").slick("slickGoTo", 1);
    }
    if ($(".trikot-product .product__media-wrapper .slider").hasClass("slick-initialized")) {
      $(".trikot-product .product__media-wrapper .slider").slick("slickGoTo", 1);
    }
  }

  /* =============================
     JS Fallback: re-fetch badges/crossref jerseys dropped by the all_products
     20-handle cap, via the Section Rendering API — each request gets its own
     fresh Liquid render, so the product always resolves there.
     + Stock validation for out-of-stock variants
  ==============================*/
  function closestSectionRoot(el) {
    return el.closest('[id^="shopify-section-"]') || document;
  }

  function replaceWithFetchedChildren(placeholderEl, sourceEl, onEachChild) {
    if (!sourceEl || !sourceEl.children.length) {
      placeholderEl.remove();
      return;
    }
    const fragment = document.createDocumentFragment();
    Array.from(sourceEl.children).forEach(function (child) {
      if (onEachChild) onEachChild(child);
      fragment.appendChild(child);
    });
    placeholderEl.replaceWith(fragment);
  }

  // The fallback render has no host jersey context, so it is the same for every size: keep it per
  // handle and a size change re-inserts the badge at once instead of blinking out for a second fetch.
  const badgeFallbackHtmlByHandle = {};

  function insertBadgeFallback(el, handle, html) {
    const doc = new DOMParser().parseFromString(html, 'text/html');

    replaceWithFetchedChildren(el, doc.querySelector('.trikot-badge-fallback-content'));

    const priceTarget = closestSectionRoot(el).querySelector(
      `.trikots-product-placeholder[data-category="badge-price"][data-handle="${handle}"]`
    );
    if (priceTarget) {
      replaceWithFetchedChildren(priceTarget, doc.querySelector('.trikot-badge-price-slot-content'));
    }
  }

  function loadBadgeFallback(el) {
    const handle = el.dataset.handle;
    if (badgeFallbackHtmlByHandle[handle]) {
      insertBadgeFallback(el, handle, badgeFallbackHtmlByHandle[handle]);
      return;
    }
    fetch(`/products/${handle}?section_id=trikot-badge-fallback`)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        badgeFallbackHtmlByHandle[handle] = html;
        insertBadgeFallback(el, handle, html);

        console.info('[trikots] Fallback loaded badge:', handle);
      })
      .catch(function (err) {
        console.warn('[trikots] Could not fetch fallback badge:', handle, err);
      });
  }

  function loadCrossrefFallback(el) {
    const handle = el.dataset.handle;
    const orderValue = el.dataset.order;
    fetch(`/products/${handle}?section_id=trikot-crossref-fallback`)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        replaceWithFetchedChildren(el, doc.querySelector('.trikot-crossref-fallback-content'), function (child) {
          if (orderValue) child.style.order = orderValue;
        });
        console.info('[trikots] Fallback loaded crossref:', handle);
      })
      .catch(function (err) {
        console.warn('[trikots] Could not fetch fallback crossref:', handle, err);
      });
  }

  function initFallbackProducts() {
    const placeholders = document.querySelectorAll('.trikots-product-placeholder[data-handle]');
    if (!placeholders.length) return;

    placeholders.forEach(function (el) {
      const handle = el.dataset.handle;
      const category = el.dataset.category;
      if (!handle) return;

      if (category === 'badge') {
        loadBadgeFallback(el);
        return;
      }

      if (category === 'crossref') {
        loadCrossrefFallback(el);
        return;
      }

      if (category === 'badge-price') {
        // Filled in by loadBadgeFallback() for the matching "badge" placeholder above.
        return;
      }

      // Legacy path: spieler / individuell placeholders.
      fetch(`/products/${handle}.json`)
        .then(function (res) { return res.json(); })
        .then(function (data) {
          if (!data || !data.product) return;
          const product = data.product;

          el.dataset.productJson = JSON.stringify(product);
          el.style.display = '';

          console.info('[trikots] Fallback loaded product:', handle, product.title);
        })
        .catch(function (err) {
          console.warn('[trikots] Could not fetch product:', handle, err);
        });
    });
  }

  function enforceStockAvailability() {
    const $activeProduct = $(".active-product").first();
    if (!$activeProduct.length) return;

    $activeProduct.find('.custom-dropdown-list li[data-available="false"]').each(function () {
      $(this).addClass('out-of-stock');
      $(this).css({ opacity: '0.4', pointerEvents: 'none' });
    });

    $activeProduct.find('select option[data-available="false"]').each(function () {
      $(this).prop('disabled', true);
    });

    $activeProduct.find('.hidden_product_input[data-available="false"] input[type="checkbox"]').each(function () {
      $(this).prop('disabled', true);
    });

    $activeProduct.find('.hidden_product_input.out-of-stock').each(function () {
      $(this).css({ opacity: '0.4', pointerEvents: 'none' });
    });
  }

  // Man of the Match: free-flocking highlight, driven by window.FCB_MAN_OF_THE_MATCH
  // (aico_metafields.man_of_the_match, exposed in snippets/global-variables.liquid as
  // {playerName, playerNumber, validFrom, validUntil} or {}). Display only - the checkout
  // discount is applied by the MOTM Shopify discount, the cart mirrors it in Liquid.
  const MOTM_NOTICE_BADGE = "Man of the Match";
  const MOTM_ROW_BADGE = "MOTM Rabatt";
  const MOTM_FREE_TEXT = "Kostenlos";
  const MOTM_OPTION_SUFFIX = " (kostenlos)"; // hidden <select>, parity only

  function motmFold(raw) {
    return String(raw || "")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .toLowerCase()
      .trim();
  }

  function motmEscape(raw) {
    return String(raw == null ? "" : raw).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  // active entry or null; aico writes {} when inactive, so guard on playerName + window
  function motmActiveEntry() {
    const entry = window.FCB_MAN_OF_THE_MATCH;
    if (!entry || !entry.playerName || !entry.playerNumber) return null;
    const now = Date.now();
    if (entry.validFrom && new Date(entry.validFrom).getTime() > now) return null;
    if (entry.validUntil && new Date(entry.validUntil).getTime() <= now) return null;
    return entry;
  }

  // same matching rule as the fcb-motm-discount Function
  function motmMatches(playerNo, playerName) {
    const entry = motmActiveEntry();
    if (!entry) return false;
    return (
      String(playerNo || "").trim() === String(entry.playerNumber).trim() &&
      motmFold(playerName || "") === motmFold(entry.playerName)
    );
  }

  // remaining time until validUntil, split for the labelled countdown
  function motmRemainingParts(entry) {
    const total = Math.max(0, Math.floor((new Date(entry.validUntil).getTime() - Date.now()) / 1000));
    return {
      total: total,
      days: Math.floor(total / 86400),
      hours: Math.floor((total % 86400) / 3600),
      minutes: Math.floor((total % 3600) / 60),
      seconds: total % 60,
    };
  }

  // "1 Tag 5 Std 4 Min 33 Sek" for the row's small line
  function motmRemainingCompact(parts) {
    const out = [];
    if (parts.days > 0) out.push(parts.days + (parts.days === 1 ? " Tag" : " Tage"));
    out.push(parts.hours + " Std", parts.minutes + " Min", parts.seconds + " Sek");
    return out.join(" ");
  }

  // Tage / Std / Min / Sek cells with the unit under each number (match-countdown
  // style). The Tage cell only shows once the window is a day or longer.
  function motmCountdownHtml() {
    const cell = (key, label) =>
      '<span class="motm-countdown__cell" data-motm-cell="' + key + '"><b>00</b><small>' + label + "</small></span>";
    return (
      '<span class="motm-countdown" data-motm-countdown-cells>' +
      cell("days", "Tage") +
      '<span class="motm-countdown__sep" data-motm-cell="days-sep">:</span>' +
      cell("hours", "Std") +
      '<span class="motm-countdown__sep">:</span>' +
      cell("minutes", "Min") +
      '<span class="motm-countdown__sep">:</span>' +
      cell("seconds", "Sek") +
      "</span>"
    );
  }

  function motmRenderCountdowns($scope, entry) {
    const parts = motmRemainingParts(entry);
    const pad = (n) => String(n).padStart(2, "0");
    $scope.find("[data-motm-countdown]").text(motmRemainingCompact(parts));
    $scope.find("[data-motm-countdown-cells]").each(function () {
      const $c = $(this);
      $c.find('[data-motm-cell="days"], [data-motm-cell="days-sep"]').prop("hidden", parts.days <= 0);
      $c.find('[data-motm-cell="days"] b').text(pad(parts.days));
      $c.find('[data-motm-cell="hours"] b').text(pad(parts.hours));
      $c.find('[data-motm-cell="minutes"] b').text(pad(parts.minutes));
      $c.find('[data-motm-cell="seconds"] b').text(pad(parts.seconds));
    });
  }

  function motmEntryKey(entry) {
    return entry ? [entry.playerNumber, entry.playerName, entry.validFrom, entry.validUntil].join("|") : "";
  }
  let motmAppliedKey = null;

  // closed-dropdown header for a Spieler row: "10 Shaqiri + CHF 25.00", or
  // "10 Shaqiri KOSTENLOS" while that player is the Man of the Match
  function motmSetHeader($li) {
    const $header = $li.closest(".custom-dropdown-options").find(".custom-dropdown-select-options").first();
    if (!$header.length) return;
    const $plain = $li.clone();
    $plain.find(".motm-deco").remove();
    if ($li.hasClass("motm-free")) {
      $plain.find(".ply_price, .stock-badge").remove();
      $header.html(
        motmEscape($plain.text().replace(/\s+/g, " ").trim()) +
          ' <span class="motm-free-price">' + motmEscape(MOTM_FREE_TEXT) + "</span>"
      );
    } else {
      $header.text($plain.text().replace(/\s+/g, " ").trim());
    }
  }

  // remove every trace so a re-apply (product switch, expiry) starts from the plain list
  function motmClear($scope) {
    $scope.find(".custom-dropdown-list li.motm-free").each(function () {
      const $li = $(this);
      $li.removeClass("motm-free").find(".motm-deco").remove();
      const no = ($li.attr("data-player_no") || "").trim();
      $li.css("order", no !== "" && !isNaN(no) ? no : ""); // Liquid renders style="order:{{ player_no }}"
      if ($li.hasClass("active")) motmSetHeader($li); // selected player: header back to the real price
    });
    $scope.find('[data-content="spieler"] option[data-name]').each(function () {
      const $opt = $(this);
      const base = $opt.data("motmBaseText");
      if (base !== undefined) $opt.text(base);
    });
    $scope.find("[data-motm-notice]").prop("hidden", true).empty();
  }

  // Flocktober-style personalisation promo, defined in snippets/global-variables.liquid.
  // Display only - fcb-bundle-transform charges the reduced surcharge at cart/checkout.
  function flockPromoActive() {
    return typeof window.FCB_flockPromoActive === "function" ? window.FCB_flockPromoActive() : null;
  }

  function flockPromoLabel(promo) {
    return promo.label + " -" + promo.percent + "%";
  }

  // player rows show the promo price; the regular text is kept so the promo can end in-tab
  function applyFlockPromoRowPrices($scope) {
    const promo = flockPromoActive();
    $scope.find('[data-content="spieler"] li[data-player_name] .ply_price').each(function () {
      const $price = $(this);
      if ($price.data("flockBaseText") === undefined) $price.data("flockBaseText", $price.text());
      const baseText = $price.data("flockBaseText");
      const amount = parseFloat(String($price.closest("li").attr("data-amount") || "").replace(",", "."));
      if (!promo || isNaN(amount) || amount <= 0) {
        $price.text(baseText).removeClass("flock-promo-price");
        return;
      }
      const promoAmount = window.FCB_flockPromoAmount(amount).toFixed(2);
      $price.text(baseText.replace(/\d+[.,]\d{2}/, promoAmount)).addClass("flock-promo-price");
    });
  }

  function applyManOfTheMatchBadges() {
    const entry = motmActiveEntry();
    motmAppliedKey = motmEntryKey(entry);

    const $activeProduct = $(".active-product").first();
    if (!$activeProduct.length) return;

    applyFlockPromoRowPrices($activeProduct);

    motmClear($activeProduct);
    if (!entry) return;

    const playerLabel = String(entry.playerNumber).trim() + " " + String(entry.playerName).trim();
    let matched = 0;

    // pinned, highlighted row. Everything injected carries .motm-deco so the dropdown
    // header text (built from the li text on pick) can strip it again.
    $activeProduct.find('[data-content="spieler"] li[data-player_name]').each(function () {
      const $li = $(this);
      if (!motmMatches($li.attr("data-player_no"), $li.attr("data-player_name"))) return;
      matched++;
      $li.addClass("motm-free").css("order", -1); // both list scopes are flex columns
      const $name = $li.find(".ply_name");
      const $nm = $name.find(".ply_nm");
      const $price = $name.find(".ply_price");
      const $badge = $('<span class="motm-deco motm-badge"></span>').text(MOTM_ROW_BADGE);
      if ($nm.length) $nm.after($badge);
      else if ($price.length) $price.before($badge);
      else $name.append($badge);
      const $free = $('<span class="motm-deco motm-free-price"></span>').text(MOTM_FREE_TEXT);
      if ($price.length) $price.after($free);
      else $name.append($free);
      $li.append(
        '<span class="motm-deco motm-fine">Nur noch <span data-motm-countdown></span></span>'
      );
      if ($li.hasClass("active")) motmSetHeader($li); // already selected when the entry went live
    });

    $activeProduct.find('[data-content="spieler"] option[data-name]').each(function () {
      const $opt = $(this);
      if (!motmMatches($opt.attr("data-nummer"), $opt.attr("data-name"))) return;
      if ($opt.data("motmBaseText") === undefined) $opt.data("motmBaseText", $opt.text());
      $opt.text($opt.data("motmBaseText") + MOTM_OPTION_SUFFIX);
    });

    // notice bar above the dropdown - only when this product actually offers the player
    if (matched > 0) {
      $activeProduct.find("[data-motm-notice]").each(function () {
        $(this)
          .html(
            '<span class="motm-notice__badge">' + motmEscape(MOTM_NOTICE_BADGE) + "</span>" +
            '<span class="motm-notice__text"><b>' + motmEscape(playerLabel) + "</b> kostenlos</span>" +
            '<span class="motm-notice__timer">' + motmCountdownHtml() + "</span>"
          )
          .prop("hidden", false);
      });
    }

    motmTick();
  }

  // 1 s heartbeat: drives the countdowns, re-applies when the entry flips (upcoming ->
  // active, active -> expired) in a long-open tab
  function motmTick() {
    const entry = motmActiveEntry();
    if (motmEntryKey(entry) !== motmAppliedKey) {
      applyManOfTheMatchBadges();
      return;
    }
    if (!entry) return;
    motmRenderCountdowns($(".active-product").first(), entry);
  }

  // exposed for manual testing in devtools
  window.FCB_ApplyManOfTheMatchBadges = applyManOfTheMatchBadges;

  initFallbackProducts();
  setTimeout(enforceStockAvailability, 100);
  setTimeout(applyManOfTheMatchBadges, 100);
  setInterval(motmTick, 1000);

  const initSlickSlider = () => {
    $(".section-trikot-product .product__media_wrap").each(function () {
      const $grid = $(this);

      if (!$grid.hasClass("slick-initialized")) {
        $grid.slick({
          dots: false,
          infinite: false,
          speed: 300,
          slidesToShow: 1,
          arrows: true,
        });
      }
    });
  };

  const initSlickSliderMobile = () => {
    $(
      ".section-trikot-product .product__mobile_media-list .product__media_wrap"
    ).each(function () {
      const $gridMobile = $(this);

      if ($gridMobile.is(":visible")) {
        if (!$gridMobile.hasClass("slick-initialized")) {
          $gridMobile.slick({
            dots: false,
            infinite: false,
            speed: 300,
            slidesToShow: 1,
            arrows: true,
          });
        } else {
          $gridMobile.slick("setPosition");
        }
      }
    });
  };

  initSlickSlider();
  initSlickSliderMobile();

  $(window).resize(() => {
    initSlickSlider();
    initSlickSliderMobile();
  });

  $(document).on(
    "click",
    ".section-trikot-product .pro__variants_list .pro__variants_single a",
    function (e) {
      e.preventDefault();
      const $this = $(this);
      $this.parents(".active-product").find(".pro__variants_list .pro__variants_single a").removeClass("active");
      $this.addClass("active");
      const productHandle = $this.closest(".pro__variants_single").data("handle");
      if (!productHandle) return;
      get_trikot(productHandle, $this);
    }
  );

  function get_trikot(productHandle, $this) {
    const sectionId = "dynamic-trikot-product";
    const url = `/products/${productHandle}?section_id=${sectionId}`;
    fetch(url)
      .then((res) => res.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newSection = doc.querySelector(`.section-trikot-product`);
        const product_title = newSection.querySelector(`.pro_title`);
        const product_title_text = product_title?.textContent.trim();
        const media_gallery = newSection.querySelector(`media-gallery`);
        const Innerinfo = newSection.querySelector(`product-info`);
        // Jersey layout config (name/number positions + personalized colors &
        // fonts) for the newly selected product.
        const new_layout = newSection.querySelector('[id^="trikot-layout-"]');
        if (newSection) {
          const trikot_section = $this.parents(
            ".active-product.featured-product"
          );
          trikot_section.removeClass(function (index, className) {
            return (className.match(/\btrikot_\S+/g) || []).join(" ");
          });

          let dynamic_classname = doc.querySelector(`input[name="trikot_class_name"]`).value;

          trikot_section.addClass(dynamic_classname);
          trikot_section.find(".pro_title").text(product_title_text);
          trikot_section.find("media-gallery").replaceWith(media_gallery);
          trikot_section.find("product-info").replaceWith(Innerinfo);

          // Refresh the jersey layout config for the new product. The swap above
          // only replaced media-gallery/product-info, so getLayoutConfig() would
          // otherwise keep reading the PREVIOUS product's _wrapper (positions,
          // fonts and personalizedTextColor/personalizedNumberColor) — e.g. the
          // home jersey's red text colour bleeding onto the away jersey. Replacing
          // the stale <script id="trikot-layout-*"> makes the configurator use the
          // selected product's own colours, exactly like the PDP does.
          const $old_layout = trikot_section.find('[id^="trikot-layout-"]');
          if (new_layout) {
            if ($old_layout.length) {
              $old_layout.first().replaceWith(new_layout);
              $old_layout.slice(1).remove();
            } else {
              trikot_section.prepend(new_layout);
            }
          } else if ($old_layout.length) {
            // New product has no layout config — drop the stale one so the preview
            // falls back to the per-class default colours instead of the old product's.
            $old_layout.remove();
          }

          initSlickSlider();
          initSlickSliderMobile();
          initFallbackProducts();
          setTimeout(enforceStockAvailability, 150);
          setTimeout(applyManOfTheMatchBadges, 150);
        }
      })
      .catch((err) => console.error("Section render error:", err));
  }

  let activeBadges = [];
  $(document).on("click", '.badges_main_wrap .hidden_product_input input[type="checkbox"]', function () {
    const $this = $(this);
    const $activeProduct = $this.closest(".active-product");
    const pro_type = "Badge";
    const input = $this;
    input.toggleClass("active");
    const pro_val = input.val();
    const pro_val_LowerCase = input.val().toLowerCase();

    const pro_price = input.attr("data-price");
    const pro_amount = input.attr("data-amount");
    const pro_tag = input.attr("data-tag");
    const pro_content = input.attr("data-content");
    const isEuropa = pro_val_LowerCase.includes("europa");
    const isChecked = $this.is(":checked");

    const allBadges = $activeProduct.find(".badges_main_wrap .hidden_product_input");
    const europaBadge = allBadges.filter(function () {
      return $(this).data("content").toLowerCase().includes("europa");
    });
    const otherBadges = allBadges.not(europaBadge);

    if (isEuropa && isChecked) {
      otherBadges.addClass("badge-disabled");
      europaBadge.removeClass("badge-disabled");

      otherBadges.find('input[type="checkbox"]').each(function () {
        uncheckBadge($(this), $activeProduct);
      });
    }

    if (!isEuropa && isChecked) {
      europaBadge.addClass("badge-disabled");
      otherBadges.removeClass("badge-disabled");

      europaBadge.find('input[type="checkbox"]').each(function () {
        uncheckBadge($(this), $activeProduct);
      });
    }

    if (!isChecked) {
      const isAnySelected = allBadges.find("input:checked").length > 0;
      if (!isAnySelected) {
        allBadges.removeClass("badge-disabled");
      }
    }

    if (pro_price && pro_content) {
      const selected_price_item = $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-handle='${pro_content}']`);
      if ($(this).hasClass("active")) {
        const $grossPriceWrap = $activeProduct.find(".gross_price_wrap");
        const discountPercentage = parseFloat(
          $grossPriceWrap.attr("data-discount-percentage") || "0"
        );
        const isBanned = $grossPriceWrap.attr("data-is-banned") === "true";
        const discountedAmount = parseFloat(
          selected_price_item.attr("data-discounted-amount") || "0"
        );
        const mainAmount = parseFloat(
          selected_price_item.attr("data-main-amount") || "0"
        );

        let displayPrice = pro_price;
        let shouldShowDiscount = false;

        if (
          discountPercentage > 0 &&
          !isBanned &&
          discountedAmount > 0 &&
          discountedAmount < mainAmount
        ) {
          displayPrice = "+ " + Currency + " " + discountedAmount.toFixed(2);
          shouldShowDiscount = true;
        } else {
          displayPrice = pro_price;
        }

        selected_price_item.text(displayPrice);
        selected_price_item.attr("data-type", pro_type);
        selected_price_item.attr("data-amount", pro_amount);
        selected_price_item.addClass("active");
        if (!activeBadges.includes(pro_val)) {
          activeBadges.push(pro_val);
        }
      } else {
        selected_price_item.text("");
        selected_price_item.attr("data-type", "");
        selected_price_item.attr("data-amount", "");
        selected_price_item.removeClass("active");
        selected_price_item.css("color", "");
        selected_price_item.css("font-weight", "");
        activeBadges = activeBadges.filter((item) => item !== pro_val);
      }
    }

    $activeProduct.find(".product-form .properties_badges").val(activeBadges.join(", "));
    applyTextBadgeLock($activeProduct);
    updateTrikotTotal($this);

    // Re-render the preview to show/hide badge overlays
    var canvasId = $activeProduct.find("#canvas-wrapper canvas").attr("id");
    var $printImg = getPrintImg($activeProduct);
    var secondImage = $printImg.attr("data-zoom-image");
    var secondImageSelector = $printImg;
    var currentName = $activeProduct.find(".individuell-name").val() || "";
    var currentNumber = $activeProduct.find(".individuell-nummer").val() || "";
    var spielerSelect = $activeProduct.find(".spieler_select select");
    if (spielerSelect.length && spielerSelect.val() && spielerSelect.val() !== "0") {
      var selectedOption = spielerSelect.find("option:selected");
      currentName = selectedOption.attr("data-name") || currentName;
      currentNumber = selectedOption.attr("data-nummer") || currentNumber;
    }
    var checkedBadgeCount = $activeProduct.find('.badges_main_wrap input[type="checkbox"]:checked').length;
    console.log("[trikot][badges] checkbox toggled → checked badges:", checkedBadgeCount, "| name:", currentName || "(none)", "| number:", currentNumber || "(none)", "| canvasId:", canvasId);
    if (canvasId) {
      console.log("[trikot][badges] triggering renderTshirtPreview");
      renderTshirtPreview({
        canvasId: canvasId,
        imageUrl: secondImage,
        playerName: currentName,
        playerNumber: currentNumber,
        injectIntoSelector: secondImageSelector,
        options: { numberOffsetX: 0 },
      });
    }

    // Badges render on the back/print slide — switch the gallery to it, then
    // bring the preview into view (mobile: preview sits above the options).
    goToPrintSlide($activeProduct);
    scrollToTrikotPreview($activeProduct);
  }
  );

  function uncheckBadge($input, $activeProduct) {
    const pro_val = $input.val();
    const pro_content = $input.parent().data("content");

    $input.prop("checked", false).removeClass("active");

    const selected_price_item = $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-handle='${pro_content}']`);

    selected_price_item.text("");
    selected_price_item.attr("data-type", "");
    selected_price_item.attr("data-amount", "");
    selected_price_item.removeClass("active");

    if (typeof activeBadges !== "undefined") {
      activeBadges = activeBadges.filter((item) => item !== pro_val);
    }
  }

  // Re-draw the canvas preview for the active product using whatever name/number
  // is currently configured (Spieler dropdown or Individuell fields).
  // Returns the render promise so callers (the submit-time guard in
  // product-form.js) can await a fresh preview instead of guessing when it is done.
  function rerenderTrikotPreview($activeProduct) {
    var canvasId = $activeProduct.find("#canvas-wrapper canvas").attr("id");
    if (!canvasId) return Promise.resolve();
    var $printImg = getPrintImg($activeProduct);
    var secondImage = $printImg.attr("data-zoom-image");
    var currentName = $activeProduct.find(".individuell-name").val() || "";
    var currentNumber = $activeProduct.find(".individuell-nummer").val() || "";
    var spielerSelect = $activeProduct.find(".spieler_select select");
    if (spielerSelect.length && spielerSelect.val() && spielerSelect.val() !== "0") {
      var selectedOption = spielerSelect.find("option:selected");
      currentName = selectedOption.attr("data-name") || currentName;
      currentNumber = selectedOption.attr("data-nummer") || currentNumber;
    }
    return renderTshirtPreview({
      canvasId: canvasId,
      imageUrl: secondImage,
      playerName: currentName,
      playerNumber: currentNumber,
      injectIntoSelector: $printImg,
      options: { numberOffsetX: 0 },
    });
  }
  // The submit-time preview guard in product-form.js calls this when the preview
  // file is missing or stale, and AWAITS the returned promise so the customer
  // gets the finished preview on the same click instead of an error + retry.
  window.fcbRerenderTrikotPreview = rerenderTrikotPreview;

  // A "text badge" (AICO metafield ist_textbadge, e.g. Allianz) forces the name
  // below the number. When one is selected we remember the user's current
  // OBEN/UNTEN choice, lock the toggle to UNTEN and surface the hint; releasing
  // all text badges restores the remembered choice and manual control.
  function applyTextBadgeLock($activeProduct) {
    const hasTextBadge = $activeProduct
      .find('.badges_main_wrap input[type="checkbox"]:checked')
      .filter(function () {
        return $(this).attr("data-is-text-badge") === "true";
      }).length > 0;

    const $buttons = $activeProduct.find(".flock-position-btn");
    const $hint = $activeProduct.find(".flock-position-hint");
    const $flock = $activeProduct.find(".properties_flock_position");

    if (hasTextBadge) {
      // Remember the manual choice once, on the transition into the locked state,
      // so a second text badge doesn't overwrite it with the forced "unten".
      if (typeof $activeProduct.data("flockPositionBeforeLock") === "undefined") {
        const current = String($flock.val() || "oben").trim().toLowerCase() === "unten" ? "unten" : "oben";
        $activeProduct.data("flockPositionBeforeLock", current);
      }
      $flock.val("unten");
      $buttons.removeClass("active").prop("disabled", true);
      $activeProduct.find('.flock-position-btn[data-position="unten"]').addClass("active");
      $hint.prop("hidden", false);
    } else {
      // Restore the choice the user had before the text badge forced "unten".
      const saved = $activeProduct.data("flockPositionBeforeLock");
      if (typeof saved !== "undefined") {
        const restored = saved === "unten" ? "unten" : "oben";
        $flock.val(restored);
        $buttons.removeClass("active").prop("disabled", false);
        $activeProduct.find('.flock-position-btn[data-position="' + restored + '"]').addClass("active");
        $activeProduct.removeData("flockPositionBeforeLock");
      } else {
        $buttons.prop("disabled", false);
      }
      $hint.prop("hidden", true);
    }
    return hasTextBadge;
  }

  // OBEN/UNTEN toggle: store choice in the hidden properties[FLOCK] input and re-render.
  $(document).on("click", ".flock-position-btn", function () {
    const $btn = $(this);
    const $activeProduct = $btn.closest(".active-product");
    const position = $btn.attr("data-position") === "unten" ? "unten" : "oben";
    $activeProduct.find(".flock-position-btn").removeClass("active");
    $btn.addClass("active");
    $activeProduct.find(".properties_flock_position").val(position);
    rerenderTrikotPreview($activeProduct);
    scrollToTrikotPreview($activeProduct);
  });

  $(document).on("click", ".individuell-nummer-dropdown-wrap .individuell-nummer-list li", function () {
    const $li = $(this);
    if (!$li.is("[data-val]")) return; // ignore the sticky search row
    const $activeProduct = $li.closest(".active-product");
    const $dropdown = $li.closest(".custom-dropdown-options");
    const selectedVal = $li.attr("data-val") || "";
    const selectedNo = $li.attr("data-player_no") || "";
    const isAvailable = $li.attr("data-available") !== "false";

    if (!isAvailable && selectedVal !== "") {
      return;
    }

    $dropdown.find(".individuell-nummer-search").val(selectedVal);
    $dropdown.find(".custom-dropdown-select-options").toggleClass("has-value", selectedVal !== "");
    $dropdown.removeClass("active");
    $dropdown.find(".custom-dropdown-list").removeClass("active");

    $activeProduct.find(".individuell-nummer").val(selectedNo);
    $('.nummer-error').text('');

    const $individual_no_selector = $activeProduct.find(".data-option-individuell");
    if ($individual_no_selector.length) {
      $individual_no_selector.find('input[type="checkbox"]').attr('data-nummer', '').prop('checked', false);
      if (selectedVal) {
        $individual_no_selector.find('input[value="' + selectedVal + '"]').prop('checked', true);
      }
    }

    individual_option($li);
    scrollToTrikotPreview($activeProduct);
  });

  // The Nr field is a search box: clicking/focusing opens the list; typing
  // filters by prefix and auto-selects the typed number if it is in stock.
  $(document).on("click keyup focus", ".individuell-nummer-search", function (e) {
    e.stopPropagation();
  });
  $(document).on("focus click", ".individuell-nummer-search", function () {
    const $opts = $(this).closest(".custom-dropdown-options");
    $(this).closest(".active-product").find(".custom-dropdown-options").not($opts)
      .removeClass("active").find(".custom-dropdown-list").removeClass("active");
    $opts.addClass("active");
    $opts.find(".custom-dropdown-list").addClass("active");
  });
  $(document).on("keyup", ".individuell-nummer-search", function () {
    const $input = $(this);
    const $activeProduct = $input.closest(".active-product");
    const $opts = $input.closest(".custom-dropdown-options");
    const $list = $opts.find(".individuell-nummer-list");
    let q = ($input.val() || "").replace(/[^0-9]/g, "");
    if (($input.val() || "") !== q) { $input.val(q); }

    // keep the list open and filter by prefix
    $opts.addClass("active");
    $list.addClass("active");
    $opts.find(".custom-dropdown-select-options").toggleClass("has-value", q !== "");
    $list.find("li[data-val]").each(function () {
      const v = $(this).attr("data-val") || "";
      $(this).toggleClass("nummer-hidden", !(q === "" || v.indexOf(q) === 0));
    });

    // auto-select the exact number if it exists and is in stock
    const $exact = q === "" ? $() : $list.find('li[data-val="' + q + '"]');
    const $no = $activeProduct.find(".individuell-nummer");
    const $sel = $activeProduct.find(".data-option-individuell");
    $sel.find('input[type="checkbox"]').attr("data-nummer", "").prop("checked", false);
    if ($exact.length && $exact.attr("data-available") !== "false") {
      $no.val(q);
      $(".nummer-error").text("");
      $sel.find('input[value="' + q + '"]').prop("checked", true);
    } else if ($exact.length) {
      $no.val("");
      $(".nummer-error").text("Diese Nummer ist ausverkauft.");
    } else {
      $no.val("");
      $(".nummer-error").text("");
    }
    individual_option($input);
  });

  // Clear (X) button inside the Nr box: remove the selected/typed number.
  $(document).on("click", ".individuell-nummer-clear", function (e) {
    e.stopPropagation();
    const $activeProduct = $(this).closest(".active-product");
    const $box = $(this).closest(".custom-dropdown-select-options");
    const $opts = $box.closest(".custom-dropdown-options");
    $box.find(".individuell-nummer-search").val("");
    $box.removeClass("has-value");
    $activeProduct.find(".individuell-nummer").val("");
    $(".nummer-error").text("");
    $activeProduct.find(".data-option-individuell input[type='checkbox']").attr("data-nummer", "").prop("checked", false);
    $opts.find(".individuell-nummer-list li[data-val]").removeClass("nummer-hidden");
    $opts.removeClass("active").find(".custom-dropdown-list").removeClass("active");
    individual_option($activeProduct.find(".individuell-nummer"));
  });

  // Close the number dropdown when clicking outside it.
  $(document).on("click", function (e) {
    if (!$(e.target).closest(".individuell-nummer-dropdown-wrap").length) {
      $(".individuell-nummer-dropdown-wrap .custom-dropdown-options").removeClass("active")
        .find(".custom-dropdown-list").removeClass("active");
    }
  });

  $(document).on("change keyup focusout", ".individuell-nummer:not([type=hidden])", function (e) {
    var $this = $(this);
    const $activeProduct = $this.closest(".active-product");
    var n = $(this).val();

    $('.nummer-error').text('');
    const allowedKeys = ["Backspace", "Delete", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Tab"];

    if (e.key >= '0' && e.key <= '9') {
    } else {
      if (allowedKeys.includes(e.key) || typeof e.key == 'undefined') {
        $('.nummer-error').text('');
      } else {
        $('.nummer-error').text('Nur Nummern erlaubt.');
      }
    }

    if (n < 0) {
      $activeProduct.find(".individuell-nummer").val(0);
    } else if (n > 99) {
      $activeProduct.find(".individuell-nummer").val(99);
    }

    individual_option($this);
  });

  $(document).on("click", ".individual_dropdown_wrap .custom-dropdown-list li", function () {
    const $activeProduct = $(this).closest(".active-product");
    const $dropdown = $(this).closest(".custom-dropdown-options");
    const selectedText = $(this).text();
    const selectedVal = $(this).attr("data-val") || "";

    $dropdown.find(".custom-dropdown-select-options").text(selectedText);

    $dropdown.removeClass("active");
    $dropdown.find(".custom-dropdown-list").removeClass("active");

    const $individual_no_selector = $activeProduct.find(".data-option-individuell");
    if ($individual_no_selector) {
      if (selectedVal != '') {
        $individual_no_selector.find(`input[type="checkbox"]`).attr('data-nummer', '');
        $individual_no_selector.find(`input[type="checkbox"]`).attr('data-name', '');
        $individual_no_selector.find(`input[type="checkbox"]`).prop('checked', false);
        $individual_no_selector.find(`input[value="${selectedVal}"]`).prop('checked', true);
      } else {
        $individual_no_selector.find(`input[type="checkbox"]`).attr('data-nummer', '');
        $individual_no_selector.find(`input[type="checkbox"]`).attr('data-name', '');
        $individual_no_selector.find(`input[type="checkbox"]`).prop('checked', false);
      }
    }

    individual_option($(this));
  }
  );

  $(document).on("change keyup focusout", ".individuell-name", function () {
    let $this = $(this);
    const $activeProduct = $this.closest(".active-product");
    let txtInput = $(this).val();
    let txtInput_lower = txtInput.toLowerCase();

    let badWord = "fuck";
    if (txtInput_lower.indexOf(badWord) != -1) {
      let txtInputnew = txtInput_lower.replace(badWord, "");
      $activeProduct.find(".individuell-name").val(txtInputnew);
    } else {
      $activeProduct.find(".individuell-name").val(txtInput);
    }

    if (txtInput.length > 12) {
      $('.name-error').text('Maximal 12 Zeichen erlaubt.');
      let newinputName = txtInput.substring(0, 12);
      $activeProduct.find(".individuell-name").val(newinputName);

    } else {
      $('.name-error').text('');
    }
    individual_option($this);
  });

  $(document).on("click", ".custom-dropdown-select-options", function (e) {
    e.stopPropagation();
    const $activeProduct = $(this).closest(".active-product");
    const $dropdown = $(this).closest(".custom-dropdown-options");

    $activeProduct.find(".custom-dropdown-options").not($dropdown).removeClass("active").find(".custom-dropdown-list").removeClass("active");

    $dropdown.toggleClass("active");
    $dropdown.find(".custom-dropdown-list").toggleClass("active");
  });

  function pickSpieler($li, scroll) {
    const $activeProduct = $li.closest(".active-product");
    const $dropdown = $li.closest(".custom-dropdown-options");
    const selectedVal = $li.attr("data-val");

    // header: plain "Nr Name + CHF x" or "Nr Name KOSTENLOS" for the Man of the Match row
    motmSetHeader($li);

    $dropdown.removeClass("active");
    $dropdown.find(".custom-dropdown-list").removeClass("active");

    const $select = $activeProduct.find(".spieler_select select");
    if ($select.find(`option[value="${selectedVal}"]`).length) {
      $select.val(selectedVal).trigger("change");
    }

    spilier_option($li);
    if (scroll) scrollToTrikotPreview($activeProduct);
  }

  $(document).on("click", ".spieler_dropdown_wrap .custom-dropdown-list li", function () {
    pickSpieler($(this), true);
  }
  );

  // Deep link from the player page: ?spieler=10 (number) or ?spieler=shaqiri (print name)
  // preselects that player. Size and badges stay open for the customer to choose.
  // Product pages only: the shop page swaps jerseys in place, so the link cannot say which one.
  const onProductPage = /\/products\//.test(window.location.pathname);
  const urlSpieler = onProductPage ? (new URLSearchParams(window.location.search).get("spieler") || "").trim().toLowerCase() : "";

  function findUrlSpielerLi($activeProduct) {
    if (!urlSpieler || !$activeProduct.length) return $();
    const byNumber = /^\d+$/.test(urlSpieler);
    return $activeProduct.find(".spieler_dropdown_wrap .custom-dropdown-list li[data-player_name]").filter(function () {
      const $li = $(this);
      return byNumber
        ? ($li.attr("data-player_no") || "").trim() === urlSpieler
        : ($li.attr("data-player_name") || "").trim() === urlSpieler;
    }).first();
  }

  function applyUrlSpieler() {
    const $li = findUrlSpielerLi($(".active-product").first());
    if (!$li.length || $li.attr("data-available") === "false") return;
    pickSpieler($li, false);
  }

  // runs after enforceStockAvailability / applyManOfTheMatchBadges (100 ms)
  setTimeout(applyUrlSpieler, 150);

  /*$(document).on("click", function (e) {
    if (!$(e.target).closest(".custom-dropdown-select-options").length) {
      $(".custom-dropdown-list").removeClass("active");
      $(".custom-dropdown-options").removeClass("active");
    }
  });*/

  $(document).mouseup(function (e) {
    var container = $(".custom-dropdown-options");

    // if the target of the click isn't the container nor a descendant of the container
    if (!container.is(e.target) && container.has(e.target).length === 0) {
      $(".custom-dropdown-list").removeClass("active");
      $(".custom-dropdown-options").removeClass("active");
    }
  });


  /*$(document).on("click",".active-product .custom-dropdown-main-wrap .custom-dropdown-selected-wrap",function () {
      $(this).parent().toggleClass("active");
    }
  );*/

  $(document).on("change", ".product-form__input--dropdown .spieler_select select", function () {
    var $this = $(this);
    const $activeProduct = $this.closest(".active-product");
    var value = $this.val();

    if (value && value != 0) {
      $activeProduct.find(".individuell-nummer").val("");
      $activeProduct.find(".individuell-name").val("");
      $activeProduct.find(".individuell-nummer-dropdown-wrap .individuell-nummer-search").val("");
      $activeProduct.find(".individuell-nummer-dropdown-wrap .custom-dropdown-select-options").removeClass("has-value");

      $activeProduct.find(".individual_dropdown_wrap .custom-dropdown-main-wrap .custom-dropdown-main-wrap .custom-dropdown-list li").removeClass("active");
      $activeProduct.find(".individual_dropdown_wrap .custom-dropdown-main-wrap .custom-dropdown-select-options").text("Nr");

      $activeProduct.find(".hidden_product_input[data-content='individuell'] input[type='checkbox']").prop("checked", false);
      $activeProduct.find(".product-form .properties_flock").val(value);
    }

    let closestProductInfo = $(this).closest("product-info");
    let product_form__error_message_wrapper = $(closestProductInfo).find(".product-form__error-message-wrapper");
    let product_form__error_message = $(closestProductInfo).find(".product-form__error-message");
    product_form__error_message_wrapper.attr("hidden", true);
    product_form__error_message.text("");

    syncSpielerUrl($this);
  }
  );

  // Mirror the chosen player into ?spieler= so a copied link reopens the jersey with that
  // player. replaceState only rewrites the address bar, the page does not reload.
  function syncSpielerUrl($select) {
    if (!onProductPage) return;
    const $option = $select.find("option:selected");
    const chosen = $option.val() && $option.val() !== "0";
    const spieler = chosen ? ($option.attr("data-nummer") || "").trim() || ($option.attr("data-name") || "").trim().toLowerCase() : "";
    const url = new URL(window.location.href);
    if (spieler) url.searchParams.set("spieler", spieler);
    else url.searchParams.delete("spieler");
    if (url.href !== window.location.href) window.history.replaceState(window.history.state, "", url);
  }

  function spilier_option($this) {
    const $activeProduct = $this.closest(".active-product");
    $activeProduct.find(".custom-dropdown-main-wrap .custom-dropdown-list li").removeClass("active");
    $this.addClass("active");
    let price = $this.attr("data-price");
    let amount = $this.attr("data-amount");
    // Man of the Match: this option is free today (display only)
    const isMotmFree = motmMatches($this.attr("data-player_no"), $this.attr("data-player_name"));

    const pro_tag = $this.parent().attr("data-tag");
    const pro_type = $this.parent().attr("data-type");
    if (price) {
      const type_price_item = $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item.active[data-type='${pro_type}']`);
      if (type_price_item.length > 0) {
        type_price_item.text("");
        type_price_item.attr("data-type", "");
        type_price_item.attr("data-amount", "");
        type_price_item.removeClass("active");
      }
      const selected_price_item = $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-handle='${pro_tag}']`);

      const $grossPriceWrap = $activeProduct.find(".gross_price_wrap");
      const discountPercentage = parseFloat(
        $grossPriceWrap.attr("data-discount-percentage") || "0"
      );
      const isBanned = $grossPriceWrap.attr("data-is-banned") === "true";
      const discountedAmount = parseFloat(selected_price_item.attr("data-discounted-amount") || "0");
      const mainAmount = parseFloat(selected_price_item.attr("data-main-amount") || "0");

      let displayPrice = price;
      let shouldShowDiscount = false;

      if (isMotmFree) {
        displayPrice = "+ " + Currency + " 0.00";
        amount = "0.00";
        shouldShowDiscount = true;
      } else if (
        discountPercentage > 0 &&
        !isBanned &&
        discountedAmount > 0 &&
        discountedAmount < mainAmount
      ) {
        displayPrice = "+ " + Currency + " " + discountedAmount.toFixed(2);
        shouldShowDiscount = true;
      }

      selected_price_item.text(displayPrice);
      selected_price_item.attr("data-type", pro_type);
      selected_price_item.attr("data-amount", amount);
      // read by updateTrikotTotal to zero the flat SPIELER_PRICE below
      selected_price_item.attr("data-motm-free", isMotmFree ? "true" : "false");
      selected_price_item.addClass("active");

      // Bill the player's number per digit too (parity with the custom number):
      // (re)activate the shared ziffer price slot and stamp its digit count so
      // updateTrikotTotal adds one ziffer price per digit. The matching per-digit
      // line items are added to the cart in product-form.js. Activated directly
      // (not via applyIndividuellPrice) because the ziffer checkboxes aren't
      // checked in the Spieler flow. The Flock cleanup above deactivates it when
      // switching/clearing players.
      const spieler_no_disp = ($this.attr("data-player_no") || "").trim();
      if (spieler_no_disp) {
        const $zbox = $activeProduct
          .find('.hidden_product_input[data-content="individuell"] .data-option-individuell input[type="checkbox"][value="' + String(spieler_no_disp).charAt(0) + '"]')
          .first();
        if ($zbox.length) {
          const zTag = $zbox.attr("data-tag");
          const $zslot = $activeProduct.find(
            `.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-handle='${zTag}']`
          );
          if ($zslot.length) {
            $zslot.text($zbox.attr("data-price") || "");
            $zslot.attr("data-type", $zbox.attr("data-type") || "Flock");
            $zslot.attr("data-amount", $zbox.attr("data-amount") || "");
            $zslot.attr("data-qty", String(spieler_no_disp).length);
            $zslot.addClass("active");
          }
          console.log("[trikot][price] player number:", spieler_no_disp, "→", String(spieler_no_disp).length, "digit(s) | ziffer slot found:", $zslot.length > 0, "| handle:", zTag, "| checkbox variantid:", $zbox.attr("data-variantid"));
        } else {
          console.warn("[trikot][price] player number:", spieler_no_disp, "→ no ziffer checkbox [value=\"" + String(spieler_no_disp).charAt(0) + "\"] on this product; number price will NOT show in the total.");
        }
      }

      updateTrikotTotal($this);
    } else {
      const type_price_item = $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-type='Flock']`);
      type_price_item.removeClass("active");
      type_price_item.attr("data-amount", "");
      type_price_item.text("");
    }

    let txtInput = $this.attr("data-val");
    let spieler_nummer = $this.attr("data-player_no");
    let spieler_name = $this.attr("data-player_name");
    if (txtInput) {
      addCustomHtml($activeProduct);
      $activeProduct.find(".product__media-list").each(function () {
        const $printItem = getPrintItem($(this));
        if ($printItem.length) {
          $(this).find(".product__media-item").removeClass("is-active");
          $printItem.addClass("is-active");
        }
      });
      if ($activeProduct.find(".product__media_wrap").hasClass("slick-initialized")) {
        $activeProduct.find(".product__media_wrap").slick("slickGoTo", 1);
      }
      if ($(".trikot-product .product__media-wrapper .slider").hasClass("slick-initialized")) {
        $(".trikot-product .product__media-wrapper .slider").slick("slickGoTo", 1);
      }

      const canvasId = $activeProduct.find("#canvas-wrapper canvas").attr("id");
      const $printImg = getPrintImg($activeProduct);
      const secondImage = $printImg.attr("data-zoom-image");
      const secondImageSelector = $printImg;

      if (canvasId) {
        renderTshirtPreview({
          canvasId: canvasId,
          imageUrl: secondImage,
          playerName: spieler_name,
          playerNumber: spieler_nummer,
          injectIntoSelector: secondImageSelector,
          options: {
            numberOffsetX: 0,
          },
        });
      }
    } else {

      removeCustomHtml($activeProduct);
      const $printImg = getPrintImg($activeProduct);
      const secondImage = $printImg.attr("data-zoom-image");
      $printImg.attr("src", secondImage);

      $activeProduct.find(".product__media-list").each(function () {
        $(this).find(".product__media-item").removeClass("is-active");
        $(this).find(".product__media-item").eq(0).addClass("is-active");
      });
      if ($activeProduct.find(".product__media_wrap").hasClass("slick-initialized")) {
        $activeProduct.find(".product__media_wrap").slick("slickGoTo", 0);
      }
      if ($(".trikot-product .product__media-wrapper .slider").hasClass("slick-initialized")) {
        $(".trikot-product .product__media-wrapper .slider").slick("slickGoTo", 0);
      }

      $activeProduct.find('.hidden_product_input[data-content="spieler"] .select__select').val("0").change();
      $activeProduct.find(".product-form .properties_flock").val("");
    }

    const $select = $activeProduct.find('.hidden_product_input[data-content="spieler"] select.select__select');
    if ($select.find(`option[value="${txtInput}"]`).length) {
      $select.val(txtInput).trigger("change");
    }

    updateTrikotTotal($this);
  }

  function individual_option($this) {
    const $activeProduct = $this.closest(".active-product");
    let no = $activeProduct.find(".individuell-nummer").val();
    let name = $activeProduct.find(".individuell-name").val();

    if (!no) {
      no = $activeProduct.find(".data-option-individuell input[type='checkbox']:checked").val() || "";
    }

    // Merely focusing/leaving the EMPTY custom name/number fields (e.g. tabbing
    // from the name box into the Nr box fires the name's focusout) must NOT wipe
    // a Spieler that's already chosen: with both fields empty the block below
    // would clear the player's Flock price and re-render the canvas without a
    // name/number. Only an actual name/number entry should take over the
    // personalization (that path clears the Spieler further down). So bail out
    // early when there's nothing to apply and a player is still selected.
    const $spielerSelect = $activeProduct.find(".spieler_select select");
    if (!no && !name && $spielerSelect.length && $spielerSelect.val() && $spielerSelect.val() !== "0") {
      return;
    }

    // Per-digit number pricing: a custom number bills once PER DIGIT. The first
    // digit's checkbox activates the shared ziffer price slot; the digit COUNT is
    // stored on that slot as data-qty (set below) so updateTrikotTotal multiplies
    // the ziffer price by the number of digits ("13" -> x2, matching the per-digit
    // line items added in product-form.js).
    const $num_checkboxes = $activeProduct.find(".hidden_product_input[data-content='individuell'] .data-option-individuell input[type='checkbox']");
    if ($num_checkboxes.length) {
      $num_checkboxes.prop("checked", false);
      if (no !== "") {
        $num_checkboxes.filter('[value="' + String(no).charAt(0) + '"]').prop("checked", true);
      }
    }

    let flag = 0;
    if (no == "" && name == "") {
      flag++;
    }

    if (no == '' && name == '') {
      $activeProduct.find(".product-form .properties_flock").val('');
    } else if (no != '' && name == '') {
      $activeProduct.find(".product-form .properties_flock").val(no);
    } else if (no == '' && name != '') {
      $activeProduct.find(".product-form .properties_flock").val(name);
    } else {
      $activeProduct.find(".product-form .properties_flock").val(no + " " + name);
    }

    let individuell_name_checkbox = $activeProduct.find(".hidden_product_input[data-content='individuell'] .data-option-individuell-name input[type='checkbox']");
    const hasSeparateNameProduct = individuell_name_checkbox.length > 0;

    if (hasSeparateNameProduct) {
      individuell_name_checkbox.prop("checked", false);
    } else {
      individuell_name_checkbox = $activeProduct.find(".hidden_product_input[data-content='individuell'] .data-option-individuell input[type='checkbox']:checked");
    }

    const individuell_no_checkbox = $activeProduct.find(".hidden_product_input[data-content='individuell'] .data-option-individuell input[type='checkbox']:checked");

    let has_individuell_number_field = false;
    if ($activeProduct.find(".individuell_fields input.individuell-nummer").length > 0) {
      has_individuell_number_field = true;
    }
    if (flag == 0) {
      $this.siblings(".error_wrapper").find(".error").text("");
      addCustomHtml($activeProduct);

      var individuell_name_checked = "";

      if (name && name != "") {
        individuell_name_checkbox.prop("checked", true);
        individuell_name_checked = individuell_name_checkbox;
        individuell_name_checkbox.attr("data-name", name);
        // individuell_no_checkbox.attr("data-name", name);
      } else {
        individuell_name_checkbox.attr("data-name", "");
        // individuell_no_checkbox.attr("data-name", "");
      }

      if (no && no != '') {
        individuell_no_checkbox.attr("data-nummer", no);
        if (has_individuell_number_field) {
          individuell_name_checkbox.attr("data-nummer", no);
        }
      } else {
        individuell_no_checkbox.attr("data-nummer", "");
        if (has_individuell_number_field) {
          individuell_name_checkbox.attr("data-nummer", "");
        }
      }

      $activeProduct.find(".product__media-list").each(function () {
        const $printItem = getPrintItem($(this));
        if ($printItem.length) {
          $(this).find(".product__media-item").removeClass("is-active");
          $printItem.addClass("is-active");
        }
      });
      if ($activeProduct.find(".product__media_wrap").hasClass("slick-initialized")) {
        $activeProduct.find(".product__media_wrap").slick("slickGoTo", 1);
      }
      if ($(".trikot-product .product__media-wrapper .slider").hasClass("slick-initialized")) {
        $(".trikot-product .product__media-wrapper .slider").slick("slickGoTo", 1);
      }

      $activeProduct.find(".spieler_dropdown_wrap .custom-dropdown-main-wrap .custom-dropdown-main-wrap .custom-dropdown-list li").removeClass("active");
      $activeProduct.find(".spieler_dropdown_wrap .custom-dropdown-main-wrap .custom-dropdown-select-options").text("Spieler auswählen ...");
      $activeProduct.find(".product-form__input--dropdown[data-content='spieler'] .select__select").val("0").trigger("change");

      const type_price_item = $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item.active[data-type='Flock']`);
      if (type_price_item.length > 0) {
        type_price_item.text("");
        type_price_item.attr("data-type", "");
        type_price_item.attr("data-amount", "");
        type_price_item.removeClass("active");
      }


      applyIndividuellPrice(individuell_name_checked, $activeProduct);
      updateTrikotTotal($this);

      applyIndividuellPrice(individuell_no_checkbox, $activeProduct);
      // Bill the ziffer slot once per digit: stamp the digit count on the active
      // slot so updateTrikotTotal multiplies its price (e.g. "13" -> x2).
      if (individuell_no_checkbox && individuell_no_checkbox.length) {
        const zTag = individuell_no_checkbox.attr("data-tag");
        const zQty = no !== "" ? String(no).length : 1;
        $activeProduct
          .find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-handle='${zTag}']`)
          .attr("data-qty", zQty);
        console.log("[trikot][price] custom number:", no, "→", zQty, "digit(s) | ziffer slot handle:", zTag, "| checkbox variantid:", individuell_no_checkbox.attr("data-variantid"));
      }
      updateTrikotTotal($this);

    } else {
      removeCustomHtml($activeProduct);
      individuell_name_checkbox.attr("data-nummer", "");
      individuell_name_checkbox.attr("data-name", "");
      individuell_no_checkbox.attr("data-nummer", "");
      individuell_no_checkbox.attr("data-name", "");
      const type_price_item = $activeProduct.find(`.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item.active[data-type='Flock']`);
      if (type_price_item.length > 0) {
        type_price_item.text("");
        type_price_item.attr("data-type", "");
        type_price_item.attr("data-amount", "");
        type_price_item.removeClass("active");
      }
      updateTrikotTotal($this);
      $this.siblings(".error_wrapper").find(".error").text("Nummer oder Name werden benötigt");
    }

    const canvasId = $activeProduct.find("#canvas-wrapper canvas").attr("id");
    const $printImg = getPrintImg($activeProduct);
    const secondImage = $printImg.attr("data-zoom-image");
    const secondImageSelector = $printImg;
    if (canvasId) {
      renderTshirtPreview({
        canvasId: canvasId,
        imageUrl: secondImage,
        playerName: name,
        playerNumber: no,
        injectIntoSelector: secondImageSelector,
        options: {
          numberOffsetX: 0,
        },
      });
    }
  }

  function addCustomHtml($activeProduct) {
    if (!$activeProduct || !$activeProduct.length) return;

    const $buttons = $activeProduct.find('.product-form__buttons');

    // Prevent duplicate insertion
    if (!$buttons.length || $activeProduct.find('.trikot_flock_msg').length) return;


    // $buttons.after(`
    //   <div class="trikot_flock_msg">
    //     Aufgrund grosser Nachfrage beträgt die Lieferzeit für bedruckte Trikots aktuell 2 Wochen.
    //   </div>
    // `);
  }

  function removeCustomHtml($activeProduct) {
    if (!$activeProduct || !$activeProduct.length) return;

    const $customHtml = $activeProduct.find('.trikot_flock_msg');
    if (!$customHtml.length) return;

    $customHtml.remove();
  }

  function resetOptions() {
    const $activeProduct = $(".active-product").first();
    removeCustomHtml($activeProduct);

    $activeProduct.find(".custom-dropdown-main-wrap .custom-dropdown-list li").removeClass("active");
    $activeProduct.find(".spieler_dropdown_wrap .custom-dropdown-main-wrap .custom-dropdown-select-options").text("Spieler auswählen ...");
    $activeProduct.find(".individual_dropdown_wrap .custom-dropdown-main-wrap .custom-dropdown-select-options").text("Nr");
    $activeProduct.find(".product-form__input--dropdown[data-content='spieler'] .select__select").val("0").trigger("change");
    $activeProduct.find(".product-form .properties_flock").val("");
    $activeProduct.find(".product-form .properties_badges").val("");

    $activeProduct.find(".flock-position-btn").removeClass("active").prop("disabled", false);
    $activeProduct.find('.flock-position-btn[data-position="oben"]').addClass("active");
    $activeProduct.find(".properties_flock_position").val("oben");
    $activeProduct.find(".flock-position-hint").prop("hidden", true);
    $activeProduct.removeData("flockPositionBeforeLock");


    const $printImg = getPrintImg($activeProduct);
    const secondImage = $printImg.attr("data-zoom-image");
    $printImg.attr("src", secondImage);

    $activeProduct.find(".product__media-list").each(function () {
      $(this).find(".product__media-item").removeClass("is-active");
      $(this).find(".product__media-item").eq(0).addClass("is-active");
    });

    if (
      $activeProduct
        .find(".product__media_wrap")
        .hasClass("slick-initialized")
    ) {
      $activeProduct.find(".product__media_wrap").slick("slickGoTo", 0);
    }
    if (
      $(".trikot-product .product__media-wrapper .slider").hasClass(
        "slick-initialized"
      )
    ) {
      $(".trikot-product .product__media-wrapper .slider").slick(
        "slickGoTo",
        0
      );
    }

    $activeProduct.find(".individuell-nummer").val("");
    $activeProduct.find(".individuell-name").val("");
    $activeProduct.find(".individuell-nummer-dropdown-wrap .individuell-nummer-search").val("");
    $activeProduct.find(".individuell-nummer-dropdown-wrap .custom-dropdown-select-options").removeClass("has-value");

    $activeProduct
      .find(
        ".hidden_product_input[data-content='individuell'] input[type='checkbox']"
      )
      .prop("checked", false);
  }

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    // product-info.js swaps #badges-<section> with the re-rendered HTML just before publishing, where the
    // all_products cap can drop a badge again (e.g. the /pages/shop trikot section). Refill those
    // placeholders right away, before the next paint, so a cached badge never visibly disappears.
    initFallbackProducts();
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const $activeProduct = $(".active-product").first();
        // a size change wipes the print; keep the deep-linked player unless the customer replaced it
        const keepUrlSpieler = findUrlSpielerLi($activeProduct).hasClass("active");

        resetOptions();
        enforceStockAvailability();
        if (keepUrlSpieler) applyUrlSpieler();

        if (
          $activeProduct.length > 0 &&
          $activeProduct.find(".product_trikot_price_wrap").length > 0
        ) {
          updateTrikotTotal($activeProduct.find(".product_trikot_price_wrap"));
        } else {
          const $productInfo = $(event.target).closest("product-info");
          if ($productInfo.length > 0) {
            const $priceWrap = $productInfo.find(".product_trikot_price_wrap");
            if ($priceWrap.length > 0) {
              updateTrikotTotal($priceWrap);
            }
          }
        }
      });
    });
  });

  $(".active-product").each(function () {
    const $activeProduct = $(this);
    const $priceWrap = $activeProduct.find(".product_trikot_price_wrap");
    if ($priceWrap.length > 0) {
      updateTrikotTotal($priceWrap);
    } else {
      const $priceElement = $activeProduct.find(".price");
      if ($priceElement.length > 0) {
        updateTrikotTotal($priceElement);
      }
    }
  });

  function applyIndividuellPrice(checkboxEl, $activeProduct) {
    if (!checkboxEl) {
      return false;
    }
    if (checkboxEl.prop("checked")) {
      const pro_tag = checkboxEl.attr("data-tag");
      const pro_type = checkboxEl.attr("data-type");
      const pro_price = checkboxEl.attr("data-price");
      let pro_amount = checkboxEl.attr("data-amount");

      const selected_price_item = $activeProduct.find(
        `.product_trikot_price_wrap .tprice_extra_wrap .hidden-price-item[data-handle='${pro_tag}']`
      );

      const $grossPriceWrap = $activeProduct.find(".gross_price_wrap");
      const discountPercentage = parseFloat(
        $grossPriceWrap.attr("data-discount-percentage") || "0"
      );
      const isBanned = $grossPriceWrap.attr("data-is-banned") === "true";
      const discountedAmount = parseFloat(
        selected_price_item.attr("data-discounted-amount") || "0"
      );
      const mainAmount = parseFloat(
        selected_price_item.attr("data-main-amount") || "0"
      );

      let displayPrice = pro_price;

      if (
        discountPercentage > 0 &&
        !isBanned &&
        discountedAmount > 0 &&
        discountedAmount < mainAmount
      ) {
        displayPrice = "+ " + Currency + " " + discountedAmount.toFixed(2);
        shouldShowDiscount = true;
      }

      selected_price_item.text(displayPrice);
      selected_price_item.attr("data-type", pro_type);
      selected_price_item.attr("data-amount", pro_amount);
      selected_price_item.addClass("active");
    }
  }

  function updateTrikotTotal($this, $type = null) {
    let $activeProduct = $this.closest(".active-product");
    if ($activeProduct.length == 0) {
      $activeProduct = $this.find(".active-product");
    }

    const $trikotPriceWrap = $activeProduct.find(".product_trikot_price_wrap");
    const isTrikotProduct = $trikotPriceWrap.length > 0;

    let main_price_el;
    let main_price;
    let main_compare_price;
    let total_main_amount = 0;

    if (isTrikotProduct) {
      main_price_el = $activeProduct.find(
        ".product_trikot_price_wrap .tprice_main .tprice_main_amount"
      );

      if (main_price_el.length > 0) {
        const dataAmount = main_price_el.attr("data-amount");
        const dataCompareAmount = main_price_el.attr("data-comapre-amount");

        main_price = parseFloat(dataAmount);
        main_compare_price = parseFloat(dataCompareAmount);
      } else {
        console.warn(
          "[updateTrikotTotal] Trikot product but price element not found, trying regular price structure"
        );

        const $priceRegular = $activeProduct.find(
          ".price .price__regular .price-item--regular"
        );
        const $priceSale = $activeProduct.find(
          ".price .price__sale .price-item--sale"
        );

        let priceText =
          $priceSale.length > 0
            ? $priceSale.text().trim()
            : $priceRegular.text().trim();

        const priceMatch = priceText.match(/[\d,]+\.?\d*/);
        if (priceMatch) {
          const priceValue = priceMatch[0].replace(",", ".");
          main_price = parseFloat(priceValue);
        }

        const $oldPrice = $activeProduct.find(
          ".price .price__sale s.price-item--regular"
        );
        if ($oldPrice.length > 0) {
          const compareText = $oldPrice.text().trim();
          const compareMatch = compareText.match(/[\d,]+\.?\d*/);
          if (compareMatch) {
            const compareValue = compareMatch[0].replace(",", ".");
            main_compare_price = parseFloat(compareValue);
          }
        }

        if (isNaN(main_price)) {
          const $variantData = $activeProduct.find(
            "script[data-selected-variant]"
          );
          if ($variantData.length > 0) {
            try {
              const variantData = JSON.parse($variantData.text());
              if (variantData && variantData.price) {
                main_price = variantData.price / 100;
                main_compare_price = variantData.compare_at_price
                  ? variantData.compare_at_price / 100
                  : null;
              }
            } catch (e) {
              console.error(
                "[updateTrikotTotal] Error parsing variant data:",
                e
              );
            }
          }
        }
      }
    }
    else {
      const $priceRegular = $activeProduct.find(
        ".price .price__regular .price-item--regular"
      );
      const $priceSale = $activeProduct.find(
        ".price .price__sale .price-item--sale"
      );

      let priceText =
        $priceSale.length > 0
          ? $priceSale.text().trim()
          : $priceRegular.text().trim();

      const priceMatch = priceText.match(/[\d,]+\.?\d*/);
      if (priceMatch) {
        const priceValue = priceMatch[0].replace(",", ".");
        main_price = parseFloat(priceValue);
      }

      const $oldPrice = $activeProduct.find(
        ".price .price__sale s.price-item--regular"
      );
      if ($oldPrice.length > 0) {
        const compareText = $oldPrice.text().trim();
        const compareMatch = compareText.match(/[\d,]+\.?\d*/);
        if (compareMatch) {
          const compareValue = compareMatch[0].replace(",", ".");
          main_compare_price = parseFloat(compareValue);
        }
      }

      if (isNaN(main_price)) {
        console.warn(
          "[updateTrikotTotal] Could not extract price from text, trying variant data"
        );

        const $variantData = $activeProduct.find(
          "script[data-selected-variant]"
        );
        if ($variantData.length > 0) {
          try {
            const variantData = JSON.parse($variantData.text());
            if (variantData && variantData.price) {
              main_price = variantData.price / 100;
              main_compare_price = variantData.compare_at_price
                ? variantData.compare_at_price / 100
                : null;
            }
          } catch (e) {
            console.error("[updateTrikotTotal] Error parsing variant data:", e);
          }
        }
      }

      if (isNaN(main_price)) {
        console.error(
          "[updateTrikotTotal] Could not determine price for regular product, aborting"
        );
        return;
      }
    }

    const $discountContainer = $activeProduct.closest(
      "[data-user-discount-percentage]"
    ).length
      ? $activeProduct.closest("[data-user-discount-percentage]")
      : $activeProduct.find("[data-user-discount-percentage]").first();

    const discountPercentageAttr =
      $discountContainer.attr("data-user-discount-percentage") || "0";
    const isBannedAttr = $discountContainer.attr("data-is-banned") || "false";
    const isBanned = isBannedAttr === "true";

    const discountPercentage = parseFloat(discountPercentageAttr);

    let total_amount = parseFloat(main_price);
    let original_total_amount = parseFloat(main_price);

    if (isTrikotProduct) {
      const active_price = $activeProduct.find(
        ".tprice_extra_wrap .hidden-price-item.active"
      );
      if (active_price.length > 0) {
        $activeProduct
          .find(".product_trikot_price_wrap .gross_price_wrap")
          .removeClass("hide_total");
      } else {
        $activeProduct
          .find(".product_trikot_price_wrap .gross_price_wrap")
          .addClass("hide_total");
      }

      const $grossPriceWrap = $activeProduct.find(".gross_price_wrap");
      const discountPercentageHidden = parseFloat(
        $grossPriceWrap.attr("data-discount-percentage") || "0"
      );
      const isBannedHidden = $grossPriceWrap.attr("data-is-banned") === "true";

      console.log(
        "[trikot][price] updateTrikotTotal | main_price:", main_price,
        "| active addon slots:", active_price.length,
        "| discount%:", discountPercentageHidden, "| banned:", isBannedHidden
      );

      // personalisation shown as one bundle price (player 25, name/number 30), badges per-item.
      // A running flock promo (Flocktober) reduces both - the cart transform charges the same.
      const SPIELER_BASE_PRICE = 25;
      const CUSTOM_BASE_PRICE = 30;
      const flockPromo = flockPromoActive();
      const SPIELER_PRICE = flockPromo ? window.FCB_flockPromoAmount(SPIELER_BASE_PRICE) : SPIELER_BASE_PRICE;
      const CUSTOM_PRICE = flockPromo ? window.FCB_flockPromoAmount(CUSTOM_BASE_PRICE) : CUSTOM_BASE_PRICE;

      let hasSpieler = false;
      let hasPersonalisation = false;
      let hasMotmFreeSpieler = false;

      active_price.each(function () {
        const $slot = $(this);
        const slotId = $slot.attr("id") || "";
        const isBadge = slotId.indexOf("hidden-price-item-bdg") === 0;
        if (isBadge) {
          // each badge shows its own real (member-discounted) price
          const full = parseFloat($slot.data("main-amount"));
          if (!isNaN(full)) {
            let eff = full;
            if (discountPercentageHidden > 0 && !isBannedHidden) {
              const d = parseFloat($slot.attr("data-discounted-amount") || "0");
              if (d > 0 && d < full) eff = d;
            }
            original_total_amount += full;
            total_amount += eff;
            total_main_amount += full;
            $slot.text("+ " + Currency + " " + eff.toFixed(2));
          }
        } else {
          // personalisation slot: blank + hide it, only the combined bundle price line shows
          hasPersonalisation = true;
          if ($slot.attr("data-addon-type") === "spieler") hasSpieler = true;
          // Man of the Match: forces SPIELER_PRICE to 0 below
          if ($slot.attr("data-motm-free") === "true") hasMotmFreeSpieler = true;
          $slot.text("").hide();
        }
      });

      const personalisation_full = hasMotmFreeSpieler
        ? 0
        : hasSpieler
          ? SPIELER_PRICE
          : hasPersonalisation
            ? CUSTOM_PRICE
            : 0;
      let personalisation_discounted = personalisation_full;
      // Flocktober: the promo price is final, the member % never stacks on it
      if (personalisation_full > 0 && discountPercentageHidden > 0 && !isBannedHidden && !flockPromo) {
        personalisation_discounted =
          personalisation_full - (personalisation_full * discountPercentageHidden) / 100;
      }

      original_total_amount += personalisation_full;
      total_amount += personalisation_discounted;
      total_main_amount += personalisation_full;

      // combined bundle price inline on the same row (css display inline, not jQuery .show)
      const $pers = $activeProduct.find(".tprice_personalisierung");
      if (personalisation_full > 0 && flockPromo) {
        // Flocktober: regular bundle price struck through, promo price, promo badge
        const personalisation_base = hasSpieler ? SPIELER_BASE_PRICE : CUSTOM_BASE_PRICE;
        $pers
          .empty()
          .append(
            document.createTextNode("+ "),
            $('<s class="flock-promo-old"></s>').text(Currency + " " + personalisation_base.toFixed(2)),
            document.createTextNode(" " + Currency + " " + personalisation_discounted.toFixed(2) + " "),
            $('<span class="flock-promo-badge"></span>').text(flockPromoLabel(flockPromo))
          )
          .css("display", "inline");
      } else if (personalisation_full > 0) {
        $pers
          .text("+ " + Currency + " " + personalisation_discounted.toFixed(2))
          .css("display", "inline");
      } else if (hasMotmFreeSpieler) {
        // Man of the Match: the player print is free. Instead of hiding the line, show the
        // bundle price it would have cost struck through plus "Kostenlos" (same treatment as
        // the dropdown row and the closed header). Display only: the totals above stay at 0.
        let motmWouldBe = SPIELER_PRICE;
        if (discountPercentageHidden > 0 && !isBannedHidden && !flockPromo) {
          motmWouldBe = SPIELER_PRICE - (SPIELER_PRICE * discountPercentageHidden) / 100;
        }
        $pers
          .empty()
          .append(
            document.createTextNode("+ "),
            $('<s class="motm-pers-old"></s>').text(Currency + " " + motmWouldBe.toFixed(2)),
            document.createTextNode(" "),
            $('<span class="motm-free-price"></span>').text(MOTM_FREE_TEXT)
          )
          .css("display", "inline");
      } else {
        $pers.text("").css("display", "none");
      }

      console.log(
        "[trikot][price] bundle → main:", main_price,
        "| personalisation:", personalisation_discounted, "(spieler:", hasSpieler, ")",
        "| grand total:", total_amount
      );
    }

    const hasComparePrice =
      !isNaN(main_compare_price) && main_compare_price > 0;
    const shouldApplyDiscount =
      !hasComparePrice &&
      !isNaN(discountPercentage) &&
      discountPercentage > 0 &&
      !isBanned;

    let discounted_total_amount = total_amount;

    if (shouldApplyDiscount) {
      const main_discount_amount = main_price * (discountPercentage / 100);
      const discounted_main_price = main_price - main_discount_amount;

      const hidden_items_total = total_amount - main_price;

      discounted_total_amount = discounted_main_price + hidden_items_total;
    }

    total_amount = shouldApplyDiscount ? discounted_total_amount : total_amount;

    console.log(
      "[trikot][price] TOTAL → main:", main_price,
      "| addons:", total_main_amount,
      "| grand total:", total_amount,
      "| original:", original_total_amount,
      "| member-discount applied:", shouldApplyDiscount
    );

    if (isNaN(total_amount)) {
      console.error(
        "[updateTrikotTotal] ERROR: total_amount is NaN! main_price:",
        main_price,
        "total_amount before:",
        total_amount
      );
      console.error("[updateTrikotTotal] Stack trace:", new Error().stack);

      if (!isNaN(main_price)) {
        total_amount = main_price;
        original_total_amount = main_price;
        console.warn(
          "[updateTrikotTotal] Using main_price as fallback:",
          main_price
        );
      } else {
        console.error(
          "[updateTrikotTotal] Cannot recover - main_price is also NaN. Aborting price update."
        );
        return;
      }
    }

    total_amount = parseFloat(total_amount.toFixed(2));
    original_total_amount = parseFloat(original_total_amount.toFixed(2));

    const total_amount_currency = `${Currency} ${total_amount.toFixed(2)}`;
    const original_total_amount_currency = `${Currency} ${original_total_amount.toFixed(
      2
    )}`;

    if (isTrikotProduct) {
      $activeProduct
        .find(
          ".product_trikot_price_wrap .gross_price_wrap .tprice_total_amount"
        )
        .text(total_amount.toFixed(2));
    }

    const $priceContainer = $activeProduct.find(".price");
    const $priceRegular = $activeProduct.find(".price .price__regular");
    const $priceSale = $activeProduct.find(".price .price__sale");

    if (shouldApplyDiscount) {
      $priceContainer.addClass("price--on-sale");

      if ($priceSale.length > 0) {
        const $oldPrice = $priceSale.find("s.price-item--regular");
        if ($oldPrice.length > 0) {
          $oldPrice.text(original_total_amount_currency);
        } else {
          $priceSale.prepend(`
            <span class="visually-hidden visually-hidden--inline">Regular price</span>
            <span>
              <s class="price-item price-item--regular">${original_total_amount_currency}</s>
            </span>
          `);
        }

        const $salePrice = $priceSale.find(".price-item--sale");
        if ($salePrice.length > 0) {
          $salePrice.text(total_amount_currency);
        } else {
          $priceSale.append(`
            <span class="visually-hidden visually-hidden--inline">Sale price</span>
            <span class="price-item price-item--sale price-item--last">${total_amount_currency}</span>
          `);
        }
      } else {
        const $priceContainerDiv = $priceContainer.find(".price__container");
        if ($priceContainerDiv.length > 0) {
          $priceContainerDiv.append(`
            <div class="price__sale">
              <span class="visually-hidden visually-hidden--inline">Regular price</span>
              <span>
                <s class="price-item price-item--regular">${original_total_amount_currency}</s>
              </span>
              <span class="visually-hidden visually-hidden--inline">Sale price</span>
              <span class="price-item price-item--sale price-item--last">${total_amount_currency}</span>
            </div>
          `);
        }
      }
    } else {
      $priceContainer.removeClass("price--on-sale");
      $activeProduct
        .find(".price .price__regular .price-item--regular")
        .text(total_amount_currency);
    }
  }

  function drawTextWithSpacing(ctx, text, centerX, y, letterSpacing) {
    const chars = text.split("");

    const totalWidth =
      ctx.measureText(text).width + (chars.length - 1) * letterSpacing;

    let startX = centerX - totalWidth / 2;

    chars.forEach((char) => {
      ctx.fillText(char, startX, y);
      startX += ctx.measureText(char).width + letterSpacing;
    });
  }

  function getLayoutConfig(canvas) {
    const scope = canvas.closest(".active-product") || document;
    const layoutEl = scope.querySelector('[id^="trikot-layout-"]');
    if (!layoutEl) return null;
    try {
      const raw = JSON.parse(layoutEl.textContent);
      if (raw && raw.layoutConfig) {
        return Object.assign({ _wrapper: raw }, JSON.parse(raw.layoutConfig));
      }
      return raw || null;
    } catch (e) {
      return null;
    }
  }

  function getSelectedBadges(canvas) {
    const scope = canvas.closest(".active-product") || document;
    const badges = [];
    scope.querySelectorAll('.badges_main_wrap input[type="checkbox"]:checked').forEach(function (input) {
      const imageUrl = input.getAttribute("data-badge-image") || input.getAttribute("data-image");
      const productId = input.getAttribute("data-badge-product-id");
      const isTextBadge = input.getAttribute("data-is-text-badge") === "true";
      const textValue = input.getAttribute("data-text-badge-value") || "";
      const textColor = input.getAttribute("data-text-badge-color") || "";
      if (isTextBadge && textValue) {
        // Text badge: render the metafield text instead of the badge image.
        badges.push({ imageUrl: imageUrl, productId: productId ? parseInt(productId) : null, isTextBadge: true, textValue: textValue, textColor: textColor });
      } else if (imageUrl) {
        badges.push({ imageUrl: imageUrl, productId: productId ? parseInt(productId) : null, isTextBadge: false, textValue: "" });
      } else {
        console.warn("[trikot][badges] checked badge has no data-badge-image/data-image, skipping:", input);
      }
    });
    console.log("[trikot][badges] getSelectedBadges →", badges.length, "badge(s):", badges.map(function (b) { return b.productId; }));
    return badges;
  }

  // Name position toggle (OBEN/UNTEN). Reads the hidden properties[FLOCK] input
  // (class .properties_flock_position) for the active product. Default: "oben".
  function getNamePosition(canvas) {
    var scope = canvas.closest(".active-product") || document;
    var el = scope.querySelector(".properties_flock_position");
    var v = el && el.value ? String(el.value).trim().toLowerCase() : "oben";
    return v === "unten" ? "unten" : "oben";
  }

  function defaultPatchPosition(index) {
    var angle = Math.PI / 2 + index * Math.PI / 4;
    return { x: 0.5 + 0.25 * Math.cos(angle), y: 0.5 + 0.25 * Math.sin(angle), scale: 1 };
  }

  // Personalized name/number fonts arrive as remote .otf URLs in the trikot
  // metafield. Load each via the FontFace API once per URL (cached) and resolve
  // to the generated font-family name so the canvas can use it. Resolves to null
  // when there's no URL or the load fails (caller falls back to default fonts).
  var personalizedFontCache = {};
  var personalizedFontSeq = 0;
  function loadPersonalizedFont(url) {
    if (!url) return Promise.resolve(null);
    if (personalizedFontCache[url]) return personalizedFontCache[url];
    var family = "TrikotPersonalized" + (++personalizedFontSeq);
    var p = new FontFace(family, 'url("' + url + '")').load().then(function (face) {
      document.fonts.add(face);
      return family;
    }).catch(function (e) {
      console.warn("[trikot][font] failed to load personalized font", url, e);
      return null;
    });
    personalizedFontCache[url] = p;
    return p;
  }

  function renderTshirtPreview({
    canvasId,
    imageUrl,
    playerName,
    playerNumber,
    injectIntoSelector = null,
    options = {},
  }) {
    const canvas = document.getElementById(canvasId);
    const ctx = canvas.getContext("2d");

    // Preview-file freshness bookkeeping (orders 8947 / 8874): renders fire per
    // keystroke and complete asynchronously, so without an epoch an OLDER render
    // can finish last and overwrite the file with a stale preview (order 8874
    // shipped a "HAMP" render for a "Hampe" order). Every render bumps the epoch
    // on the hidden file input; only the latest render may attach its PNG, and a
    // successful attach stamps the input with the name|number it was drawn from
    // so product-form.js can verify the file matches what is being sold.
    var previewScope = canvas.closest(".active-product") || document;
    var previewFileInput = previewScope.querySelector(".properties_trikot_image");
    var renderEpoch = 0;
    if (previewFileInput) {
      renderEpoch = (previewFileInput._trikotRenderEpoch || 0) + 1;
      previewFileInput._trikotRenderEpoch = renderEpoch;
    }
    function isLatestRender() {
      return !previewFileInput || previewFileInput._trikotRenderEpoch === renderEpoch;
    }
    function previewStampKey(name, number) {
      return String(name == null ? "" : name).trim().toUpperCase() + "|" + String(number == null ? "" : number).trim();
    }

    const layout = getLayoutConfig(canvas);
    const badges = getSelectedBadges(canvas);

    const image = new Image();
    image.crossOrigin = "anonymous";
    image.src = imageUrl;

    var badgeImages = badges.map(function (badge) {
      if (badge.isTextBadge) {
        // No image to load for text badges; the font is loaded via the Promise.all below.
        return { img: null, badge: badge, loaded: Promise.resolve() };
      }
      var img = new Image();
      img.crossOrigin = "anonymous";
      img.src = badge.imageUrl;
      return { img: img, badge: badge, loaded: new Promise(function (res) { img.onload = res; img.onerror = res; }) };
    });

    // Personalized fonts: the name always uses the text font; the number uses
    // its own font only when useSeparateNumberStyle is on, otherwise it mirrors
    // the name's font. Resolved family names are captured for use in the draw.
    var wrapperCfg = (layout && layout._wrapper) || {};
    var useSeparateNumberStyle = wrapperCfg.useSeparateNumberStyle === true;

    var numberFontUrl = useSeparateNumberStyle ? wrapperCfg.personalizedNumberFontUrl : wrapperCfg.personalizedTextFontUrl;
    var personalizedTextFont = null;
    var personalizedNumberFont = null;

    var renderDone = Promise.all([
      new Promise(function (res, rej) {
        image.onload = res;
        // Without an onerror handler a failed base image (404 / CORS / network)
        // left this promise pending forever, so Promise.all never resolved: the
        // canvas was never drawn and no preview file was attached — the print
        // silently went to production with no visualization (real Class-A cause).
        // Reject so the .catch below surfaces it instead of hanging.
        image.onerror = function () { rej(new Error("base jersey image failed to load: " + imageUrl)); };
      }),
      document.fonts.load("100px AngularSquared").catch(function () { }),
      document.fonts.load("100px trikot-1893FCBasel").catch(function () { }),
      document.fonts.load("100px 'FCB Home'").catch(function () { }),
      document.fonts.load("100px 'FCB Away'").catch(function () { }),
      document.fonts.load("100px allianz", "").catch(function () { }),
      loadPersonalizedFont(wrapperCfg.personalizedTextFontUrl).then(function (f) { personalizedTextFont = f; }),
      loadPersonalizedFont(numberFontUrl).then(function (f) { personalizedNumberFont = f; }),
    ].concat(badgeImages.map(function (b) { return b.loaded; }))).then(function () {
      canvas.width = image.naturalWidth;
      canvas.height = image.naturalHeight;

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(image, 0, 0);

      var wrapper = canvas.closest("media-gallery");
      var trikotClass = wrapper ? wrapper.dataset.trikotClass || "" : "";

      var classColors = {
        home_print: "#CD001A",
        away_print: "#000000, #322923",
        "3rd_print": "#FCE300",
        torwart_print: "#000000",
      };

      var rawClassColor = classColors[trikotClass] || (wrapper ? "#fff" : "#000000");

      // A class color may define two comma-separated colors: the first applies
      // to the name, the second to the number (e.g. away_print).
      var classColorParts = String(rawClassColor).split(",").map(function (c) {
        return c.trim();
      });
      var classNameColor = classColorParts[0];
      var classNumberColor = classColorParts[1] || classColorParts[0];



      var textColor;
      if (layout && layout._wrapper && layout._wrapper.personalizedTextColor) {
        textColor = layout._wrapper.personalizedTextColor;
      } else {
        textColor = classNameColor;
      }

      ctx.textAlign = "left";
      ctx.fillStyle = textColor;

      var nameX = layout && layout.nameX != null ? layout.nameX : 0.50;
      var nameY = layout && layout.nameY != null ? layout.nameY : 0.30;
      var nameScale = layout && layout.nameScale != null ? layout.nameScale : 1;
      var numberX = layout && layout.numberX != null ? layout.numberX : 0.50;
      var numberY = layout && layout.numberY != null ? layout.numberY : 0.58;
      var numberScale = layout && layout.numberScale != null ? layout.numberScale : 1;

      var numberFontRatio = 0.35 * numberScale;
      var nameFontRatio = 0.082 * nameScale;

      // FCB kit number font per trikot class (home/away have dedicated digit
      // fonts); other classes fall back to AngularSquared.
      var numberFonts = { home_print: "'FCB Home'", away_print: "'FCB Away'" };
      var classNumberFont = numberFonts[trikotClass] || "trikot-1893FCBasel";

      // Name uses the personalized text font (falls back to trikot-1893FCBasel).
      var nameFontFamily = personalizedTextFont || "trikot-1893FCBasel";

      // Number style: with useSeparateNumberStyle the number gets its own
      // personalized font + color; otherwise it mirrors the name's font + color.
      // Either branch falls back to the class digit font when no personalized
      // font was configured/loaded.
      var numberFontFamily = useSeparateNumberStyle
        ? (personalizedNumberFont || classNumberFont)
        : (personalizedTextFont || classNumberFont);
      // Number color is independent of useSeparateNumberStyle (that flag only
      // controls the number's font). Priority: an explicit personalizedNumberColor
      // always wins, then the personalized text color, then the class number color.
      var numberColor = wrapperCfg.personalizedNumberColor
        ? wrapperCfg.personalizedNumberColor
        : (layout && layout._wrapper && layout._wrapper.personalizedTextColor
          ? textColor
          : classNumberColor);

      // OBEN (default): name above the number, at nameY.
      // UNTEN: name below the number — use layout.nameYBelow if configured,
      // otherwise drop it just under the number's baseline.
      var namePosition = getNamePosition(canvas);
      var nameYResolved = nameY;
      if (namePosition === "unten") {
        nameYResolved = layout && layout.nameYBelow != null ? layout.nameYBelow : numberY + 0.12;
      }

      /* =============================
        NUMBER
      ==============================*/
      if (playerNumber) {
        ctx.fillStyle = numberColor;
        ctx.font = "normal " + (canvas.height * numberFontRatio) + "px " + numberFontFamily;
        var numberCenterX = canvas.width * numberX;
        var numberTop = canvas.height * numberY;
        // Digit spacing for the number. The kit number fonts carry wide built-in
        // advance, so tightening the gap between digits needs a NEGATIVE value.
        // Made proportional to the number's font size so the gap stays balanced
        // across jerseys regardless of numberScale. Tune NUMBER_SPACING_RATIO
        // only: 0 = font default, more negative = digits closer. (Was fixed 20.)
        //
        // History (FCB feedback, Agnes):
        //   fixed 20  -> "too far apart"        (approx +20px on the 26/27 home kit)
        //   -0.06     -> approved, then "a bit too tight"   (approx -38px)
        //   -0.014    -> midway between the two (approx  -9px)  <- current
        // Reference render for those px figures: base image 1946px tall
        // (product-thumbnail.liquid requests width: 1946 from a 2500x2500 source)
        // and numberScale 0.936, giving a number font of ~637px.
        var NUMBER_SPACING_RATIO = -0.014;
        var numberFontPx = canvas.height * numberFontRatio;
        drawTextWithSpacing(ctx, playerNumber, numberCenterX, numberTop, numberFontPx * NUMBER_SPACING_RATIO);
      }

      /* =============================
        NAME
      ==============================*/
      if (playerName) {
        ctx.fillStyle = textColor;
        var nameText = playerName.toUpperCase();
        var nameLetterSpacing = 1;
        // Fit the name inside a print box so long names never overflow the
        // jersey. Box width = a fraction of the shirt image width, centered on
        // nameX. We measure the name at its default size and, if it is wider
        // than the box, shrink the font so it fills the box exactly. Short
        // names are left untouched (growth is capped at the default size).
        // The box is narrower for UNTEN (name below the number, over the lower
        // torso/print area) than for OBEN (name across the shoulders).
        var NAME_BOX_WIDTH_RATIO_OBEN = 0.42;
        var NAME_BOX_WIDTH_RATIO_UNTEN = 0.36;
        var nameBoxRatio =
          namePosition === "unten" ? NAME_BOX_WIDTH_RATIO_UNTEN : NAME_BOX_WIDTH_RATIO_OBEN;
        var nameBoxWidth = canvas.width * nameBoxRatio;
        var nameFontPx = canvas.height * nameFontRatio;
        ctx.font = "normal " + nameFontPx + "px " + nameFontFamily;
        var nameMeasured =
          ctx.measureText(nameText).width + (nameText.length - 1) * nameLetterSpacing;
        if (nameMeasured > nameBoxWidth) {
          nameFontPx = nameFontPx * (nameBoxWidth / nameMeasured);
          ctx.font = "normal " + nameFontPx + "px " + nameFontFamily;
        }
        var nameCenterX = canvas.width * nameX;
        var nameTop = canvas.height * nameYResolved;
        drawTextWithSpacing(ctx, nameText, nameCenterX, nameTop, nameLetterSpacing);
      }

      /* =============================
        BADGES
      ==============================*/
      var patchSizeRatio = 0.13;
      console.log("[trikot][badges] rendering", badgeImages.length, "badge image(s); layout.patches keys:", layout && layout.patches ? Object.keys(layout.patches) : "(none)");
      badgeImages.forEach(function (entry, index) {
        if (!entry.badge.isTextBadge && !entry.img.naturalWidth) {
          console.warn("[trikot][badges] badge image failed to load (naturalWidth=0), skipping:", entry.badge.productId, entry.badge.imageUrl);
          return;
        }
        var patches = layout && layout.patches || {};
        var pos;
        var source;
        // Patch keys are now prefixed by badge type: "img:<aico_id>" for image
        // badges, "txt:<aico_id>" for text badges (e.g. "img:1930", "txt:1918").
        // Try the prefixed key first; fall back to the bare id for older configs
        // that were saved before the prefix was introduced.
        var prefixedKey = entry.badge.productId != null
          ? (entry.badge.isTextBadge ? "txt:" : "img:") + entry.badge.productId
          : null;
        if (prefixedKey && patches[prefixedKey]) {
          pos = patches[prefixedKey];
          source = "config(" + prefixedKey + ")";
        } else if (entry.badge.productId && patches[entry.badge.productId]) {
          pos = patches[entry.badge.productId];
          source = "config(legacy)";
        } else if (entry.badge.isTextBadge) {
          // Text badge (e.g. Allianz) always stays up — top-center — so the
          // forced "unten" player/individual name renders below it.
          pos = { x: 0.5, y: 0.22, scale: 1.2 };
          source = "text-default-top";
        } else {
          pos = defaultPatchPosition(index);
          source = "default(no patches[" + entry.badge.productId + "])";
        }
        var size = canvas.width * patchSizeRatio * (pos.scale || 1);
        var centerX = canvas.width * (pos.x || 0.5);
        var centerY = canvas.height * (pos.y || 0.5);
        var bx = centerX - size / 2;
        var by = centerY - size / 2;
        console.log("[trikot][badges] placed id", entry.badge.productId, "via", source, "→ center(", Math.round(centerX), ",", Math.round(centerY), ") size", Math.round(size) + "px");

        // Text badge: draw the metafield value (e.g. "ALLIANZ") instead of an image,
        // fitted to the patch width, using the jersey text color/font.
        if (entry.badge.isTextBadge) {
          var isAllianz = String(entry.badge.textValue).toLowerCase().indexOf("allianz") !== -1;
          // Per-badge color from the textbadge_farbe metafield (hex), falling back to the jersey text color.
          var badgeTextColor = entry.badge.textColor || textColor;
          ctx.save();
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillStyle = badgeTextColor;

          if (isAllianz) {
            // Allianz badge: draw the icon-allianz-logo glyph () from the
            // 'allianz' icon font instead of letters, fitted to the patch width.
            var glyph = "";
            var maxWLogo = size * 1.8;
            var logoSize = size * 1.1;
            ctx.font = logoSize + "px allianz";
            while (ctx.measureText(glyph).width > maxWLogo && logoSize > 6) {
              logoSize -= 1;
              ctx.font = logoSize + "px allianz";
            }
            ctx.fillText(glyph, centerX, centerY);
            ctx.restore();
            console.log("[trikot][badges] allianz badge id", entry.badge.productId, "→ drew icon-allianz-logo glyph");
            return;
          }

          var label = String(entry.badge.textValue).toUpperCase();
          var maxW = size * 1.6;
          var fontSize = size * 0.4;
          ctx.font = "normal " + fontSize + "px trikot-1893FCBasel";
          while (ctx.measureText(label).width > maxW && fontSize > 6) {
            fontSize -= 1;
            ctx.font = "normal " + fontSize + "px trikot-1893FCBasel";
          }
          ctx.fillText(label, centerX, centerY);
          ctx.restore();
          console.log("[trikot][badges] text badge id", entry.badge.productId, "→ drew text:", label);
          return;
        }

        ctx.save();
        ctx.beginPath();
        ctx.arc(bx + size / 2, by + size / 2, size / 2, 0, Math.PI * 2);
        ctx.closePath();
        ctx.clip();
        ctx.drawImage(entry.img, bx, by, size, size);
        ctx.restore();
      });

      /* =============================
        INJECT INTO SELECTOR IF NEEDED
      ==============================*/
      if (injectIntoSelector) {
        // A superseded render (a newer one started while this one was loading)
        // must not overwrite the newer preview or its file — the race that
        // shipped order 8874 with a stale "HAMP" preview for a "Hampe" order.
        if (!isLatestRender()) {
          console.warn("[trikot][preview] render superseded (epoch", renderEpoch, "<", previewFileInput._trikotRenderEpoch, ") — dropping attach for", previewStampKey(playerName, playerNumber));
          return;
        }
        try {
          // toDataURL throws a SecurityError if the canvas is tainted (a cross-origin
          // image drawn without CORS headers). It was previously OUTSIDE this try, so
          // the throw was uncaught and killed BOTH the on-page preview and the file
          // attach below — the order then shipped with no visualization. Keep it and
          // the src assignment inside the try.
          var imgData = canvas.toDataURL("image/png");
          $(injectIntoSelector).attr("src", imgData);

          var fileInput = previewFileInput;
          if (fileInput && typeof DataTransfer !== "undefined") {
            var parts = imgData.split(",");
            var mimeMatch = parts[0].match(/:(.*?);/);
            var mime = mimeMatch ? mimeMatch[1] : "image/png";
            var binary = atob(parts[1]);
            var bytes = new Uint8Array(binary.length);
            for (var i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
            var file = new File([bytes], "trikot-preview.png", { type: mime });
            var dt = new DataTransfer();
            dt.items.add(file);
            fileInput.files = dt.files;
            fileInput.dataset.trikotPreviewFor = previewStampKey(playerName, playerNumber);
          }
        } catch (err) {
          console.error("[trikot][preview] toDataURL/attach failed (canvas likely tainted by a cross-origin image):", err);
          // Don't leave a file from an EARLIER config attached — the submit guard
          // must see this render as failed rather than trust a stale preview.
          if (previewFileInput) {
            previewFileInput.value = "";
            delete previewFileInput.dataset.trikotPreviewFor;
          }
        }
      }
    }).catch(function (err) {
      // A rejected base-image load (see image.onerror above) or any unexpected error
      // in the render lands here instead of leaving Promise.all pending forever. Log
      // loudly so a missing preview is visible in monitoring rather than silent.
      console.error("[trikot][preview] render aborted — preview NOT generated:", (err && err.message) ? err.message : err);
      // If this failed render is still the latest, any previously attached file
      // no longer matches the current configuration — clear it so the submit
      // guard blocks instead of shipping a stale preview.
      if (isLatestRender() && previewFileInput) {
        previewFileInput.value = "";
        delete previewFileInput.dataset.trikotPreviewFor;
      }
    });

    // Let the submit guard in product-form.js await an in-flight render instead
    // of blocking the customer over a race it can simply wait out.
    if (previewFileInput) {
      previewFileInput._trikotRenderPending = renderDone;
      var clearPending = function () {
        if (previewFileInput._trikotRenderPending === renderDone) {
          previewFileInput._trikotRenderPending = null;
        }
      };
      renderDone.then(clearPending, clearPending);
    }

    // Settles when this render has finished drawing and attaching (or failed and
    // cleaned up) — never rejects, so callers can simply await it.
    return renderDone;
  }
});
/* ============================================================================
   White sponsor badges: some badge artwork (goalkeeper / 3rd kit logo sets) and
   some text badges are printed in white and are invisible on the white swatch
   in "BADGES WÄHLEN". Canvas-sample each badge image and flag ONLY the (near-)
   white ones with .swatch-light-artwork so product-trikots.css can give them a
   subtle light-gray panel.

   Lives here (not inline in product-trikots-options.liquid) on purpose: the
   shop-page configurator swaps jerseys via fetch + DOMParser + replaceWith
   (get_trikot above) and variant changes swap #badges-* innerHTML
   (product-info.js) — inline <script> tags never execute in either path. A
   document-level MutationObserver re-scans after every such swap instead.
   ========================================================================== */
(function () {
  var LIGHT_LUMINANCE = 225; // per-pixel "near white" cut-off (0-255)
  var LIGHT_RATIO = 0.85;    // share of visible pixels that must be near white
  var lightImageCache = {};  // image url -> Promise<boolean>, so re-scans are free

  function luminance(r, g, b) {
    return 0.299 * r + 0.587 * g + 0.114 * b;
  }

  function isLightImage(url) {
    if (!lightImageCache[url]) {
      lightImageCache[url] = new Promise(function (resolve) {
        var img = new Image();
        img.crossOrigin = "anonymous";
        img.onload = function () {
          var light = false;
          try {
            var canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth;
            canvas.height = img.naturalHeight;
            var ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            var data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
            var visible = 0;
            var nearWhite = 0;
            for (var i = 0; i < data.length; i += 4) {
              if (data[i + 3] < 128) continue; // ignore transparent padding
              visible++;
              if (luminance(data[i], data[i + 1], data[i + 2]) >= LIGHT_LUMINANCE) nearWhite++;
            }
            light = visible > 0 && nearWhite / visible >= LIGHT_RATIO;
          } catch (err) {
            console.warn("[trikot][badges] cannot sample badge image (CORS-tainted canvas?):", url, err);
          }
          resolve(light);
        };
        img.onerror = function () {
          resolve(false);
        };
        img.src = url;
      });
    }
    return lightImageCache[url];
  }

  function isLightColor(el) {
    var rgb = getComputedStyle(el).color.match(/[\d.]+/g);
    return rgb ? luminance(+rgb[0], +rgb[1], +rgb[2]) >= LIGHT_LUMINANCE : false;
  }

  function scanBadgeSwatches() {
    document.querySelectorAll(".badges_main_wrap .swatch-patches").forEach(function (label) {
      if (label.classList.contains("swatch-light-artwork")) return; // already flagged
      var textEl = label.querySelector(".text-badge-label, .text-badge-allianz");
      if (textEl) {
        if (isLightColor(textEl)) label.classList.add("swatch-light-artwork");
        return;
      }
      var fieldset = label.closest("fieldset");
      var input = fieldset && fieldset.querySelector('input[name="Patches"]');
      var url = input && (input.getAttribute("data-badge-image") || input.getAttribute("data-image"));
      if (!url) return;
      isLightImage(url).then(function (light) {
        if (light) label.classList.add("swatch-light-artwork");
      });
    });
  }

  // Debounced re-scan on any DOM swap (jersey switch on the shop page, variant
  // change re-render on the PDP). The scan itself only toggles a class
  // (attribute mutation), so it cannot re-trigger this childList observer.
  var scanTimer = null;
  function scheduleScan() {
    if (scanTimer) return;
    scanTimer = setTimeout(function () {
      scanTimer = null;
      scanBadgeSwatches();
    }, 100);
  }

  scanBadgeSwatches(); // script is deferred, DOM is parsed at this point
  new MutationObserver(scheduleScan).observe(document.body, { childList: true, subtree: true });
})();
